// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== CSS Variables ===== */
.app-root.light,
.app.light {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-toolbar: #ffffff;
  --bg-sidebar: #ffffff;
  --text-primary: #1a1a1a;
  --text-secondary: #555;
  --border-color: #ddd;
  --accent: #4a90d9;
  --accent-hover: #357abd;
  --danger: #d9534f;
  --danger-hover: #c9302c;
  --node-bg: #ffffff;
  --node-header: #d4dce4;
  --node-header-text: #1a1a1a;
  --node-field-alt: #e8ecf0;
  --node-field-selected: #cce0ff;
  --node-border: #999;
  --node-selected-border: #4a90d9;
  --enum-header: #f0e6d0;
  --enum-border: #b8a070;
  --edge-color: #555;
  --input-bg: transparent;
  --constraint-bg: #e0e0e0;
  --constraint-active: #4a90d9;
  --dropdown-bg: #fff;
  --dropdown-hover: #e8f0fe;
  --popup-bg: #fff;
  --popup-overlay: rgba(0, 0, 0, 0.3);
}

.app-root.dark,
.app.dark {
  --bg-primary: #0d1117;
  --bg-secondary: #161b22;
  --bg-toolbar: #161b22;
  --bg-sidebar: #161b22;
  --text-primary: #e6edf3;
  --text-secondary: #8b949e;
  --border-color: #30363d;
  --accent: #58a6ff;
  --accent-hover: #79b8ff;
  --danger: #f85149;
  --danger-hover: #da3633;
  --node-bg: #1c2128;
  --node-header: #2d333b;
  --node-header-text: #e6edf3;
  --node-field-alt: #22272e;
  --node-field-selected: #1f3a5f;
  --node-border: #444c56;
  --node-selected-border: #58a6ff;
  --enum-header: #3d3328;
  --enum-border: #6e5c3a;
  --edge-color: #8b949e;
  --input-bg: transparent;
  --constraint-bg: #30363d;
  --constraint-active: #58a6ff;
  --dropdown-bg: #1c2128;
  --dropdown-hover: #1f3a5f;
  --popup-bg: #1c2128;
  --popup-overlay: rgba(0, 0, 0, 0.6);
}

/* ===== Reset & Base ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-text-size-adjust: 100%;
  overflow-x: hidden;
}

/* Scrollbar - Dark theme (default) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #0d1117;
}

::-webkit-scrollbar-thumb {
  background: #444c56;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #58a6ff;
}

/* Scrollbar - Light theme */
html[data-theme="light"] ::-webkit-scrollbar-track,
html[data-theme="light"]::-webkit-scrollbar-track {
  background: #f0f0f0;
}

html[data-theme="light"] ::-webkit-scrollbar-thumb,
html[data-theme="light"]::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 10px;
}

html[data-theme="light"] ::-webkit-scrollbar-thumb:hover,
html[data-theme="light"]::-webkit-scrollbar-thumb:hover {
  background: #4a90d9;
}

.app-root {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* Page transition */
@keyframes pageSlideIn {
  from { opacity: 0; transform: translateX(12px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes pageFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.landing {
  animation: pageFadeIn 0.35s ease-out;
}

.home-page,
.app,
.profile-content {
  animation: pageSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.app-root.light { background: var(--bg-primary); color: var(--text-primary); }
.app-root.dark { background: var(--bg-primary); color: var(--text-primary); }

.app {
  width: 100vw;
  height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  overflow: hidden;
}

.main-layout {
  display: flex;
  height: 100vh;
  width: 100vw;
}

/* ===== Landing Page ===== */
.landing {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.landing-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 40px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(12px);
}

.app-root.light .landing-nav {
  background: rgba(255, 255, 255, 0.85);
}

.app-root.dark .landing-nav {
  background: rgba(22, 27, 34, 0.85);
}

.landing-logo {
  font-size: 18px;
  font-weight: 800;
  color: var(--accent);
  letter-spacing: -0.5px;
}

.landing-nav-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Language Switcher */
.lang-switcher {
  display: flex;
  gap: 2px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 2px;
}

.lang-btn {
  padding: 4px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.lang-btn:hover {
  color: var(--text-primary);
}

.lang-btn.active {
  background: var(--accent);
  color: #fff;
}

.landing-btn-ghost {
  padding: 8px 20px;
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.landing-btn-ghost:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.landing-btn-primary {
  padding: 8px 20px;
  background: var(--accent);
  border: 1px solid var(--accent);
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.landing-btn-primary:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

/* Hero */
.landing-hero {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 80px 40px;
  gap: 20px;
}

/* Split hero: text + feature card */
.landing-hero.hero-split {
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 56px;
  padding: 100px 40px 90px;
  text-align: left;
  overflow: hidden;
  max-width: 1200px;
  margin: 0 auto;
}

.hero-bg-glow {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 900px;
  height: 600px;
  background:
    radial-gradient(ellipse at 30% 30%, rgba(74, 144, 217, 0.18), transparent 60%),
    radial-gradient(ellipse at 70% 60%, rgba(124, 58, 237, 0.10), transparent 70%);
  filter: blur(40px);
  z-index: 0;
  pointer-events: none;
}

.hero-text {
  position: relative;
  z-index: 1;
  flex: 1 1 480px;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.hero-text .hero-badge {
  align-self: flex-start;
}

.hero-split .hero-title {
  font-size: clamp(36px, 4.5vw, 56px);
  line-height: 1.05;
  letter-spacing: -0.02em;
  margin: 0;
  text-align: left;
}

.hero-split .hero-desc {
  font-size: clamp(15px, 1.2vw, 17px);
  line-height: 1.6;
  color: var(--text-secondary);
  text-align: left;
  margin: 0;
}

.hero-split .hero-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 6px;
}

/* ===== Hero feature card (right side) ===== */
.hero-features {
  position: relative;
  z-index: 1;
  flex: 1 1 420px;
  max-width: 480px;
}

.hero-features-card {
  position: relative;
  border-radius: 18px;
  padding: 24px 26px;
  background:
    linear-gradient(180deg, rgba(74, 144, 217, 0.06), transparent 60%),
    var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.05) inset,
    0 24px 60px -20px rgba(74, 144, 217, 0.25),
    0 8px 30px -8px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(8px);
  overflow: hidden;
}

.hero-features-card::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(74, 144, 217, 0.5), transparent);
}

.hero-features-tag {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  background: rgba(46, 160, 67, 0.12);
  color: #2ea043;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-radius: 20px;
  margin-bottom: 18px;
}

.hero-features-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2ea043;
  box-shadow: 0 0 0 3px rgba(46, 160, 67, 0.2);
  animation: hero-feat-pulse 2.4s ease-in-out infinite;
}

@keyframes hero-feat-pulse {
  0%, 100% { box-shadow: 0 0 0 3px rgba(46, 160, 67, 0.2); }
  50%      { box-shadow: 0 0 0 5px rgba(46, 160, 67, 0); }
}

.hero-features-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hero-feat-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 9px;
  transition: all 0.2s ease;
  cursor: default;
}

.hero-feat-item:hover {
  background: rgba(74, 144, 217, 0.06);
  transform: translateX(2px);
}

.hero-feat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  flex-shrink: 0;
  background: rgba(74, 144, 217, 0.12);
  color: var(--accent);
  transition: all 0.2s ease;
}

.hero-feat-item:hover .hero-feat-icon {
  background: rgba(74, 144, 217, 0.2);
  transform: scale(1.05);
}

/* Per-icon color tints — gentle palette */
.hero-feat-icon.icon-rocket   { background: rgba(74, 144, 217, 0.12);  color: #4a90d9; }
.hero-feat-icon.icon-lock     { background: rgba(46, 160, 67, 0.12);   color: #2ea043; }
.hero-feat-icon.icon-globe    { background: rgba(124, 58, 237, 0.14);  color: #7c3aed; }
.hero-feat-icon.icon-database { background: rgba(240, 173, 78, 0.14);  color: #f0ad4e; }
.hero-feat-icon.icon-backup   { background: rgba(228, 77, 144, 0.12);  color: #e44d90; }
.hero-feat-icon.icon-pulse    { background: rgba(99, 102, 241, 0.14);  color: #6366f1; }
.hero-feat-icon.icon-sync     { background: rgba(46, 160, 67, 0.12);   color: #2ea043; }
.hero-feat-icon.icon-mail     { background: rgba(74, 144, 217, 0.12);  color: #4a90d9; }

.hero-feat-text {
  font-size: 13.5px;
  line-height: 1.4;
  color: var(--text-primary);
  font-weight: 500;
}

@media (max-width: 980px) {
  .landing-hero.hero-split {
    flex-direction: column;
    gap: 36px;
    padding: 64px 24px 56px;
  }
  .hero-text {
    align-items: center;
    text-align: center;
    max-width: 600px;
  }
  .hero-text .hero-badge,
  .hero-split .hero-title,
  .hero-split .hero-desc,
  .hero-split .hero-actions {
    text-align: center;
    justify-content: center;
    align-self: center;
  }
  .hero-features { max-width: 540px; width: 100%; }
}

@media (max-width: 540px) {
  .hero-features-card { padding: 20px 18px; }
  .hero-feat-text { font-size: 13px; }
  .hero-feat-icon { width: 28px; height: 28px; }
}

/* Two-column hero: text left, stacked showcase right */
.landing-hero.hero-two-col {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  padding: 40px 28px 40px max(48px, calc(50vw - 600px));
  max-width: none;
  margin: 0;
  text-align: left;
}

.hero-text-col {
  flex: 1 1 500px;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  padding: 40px 0;
}

.hero-text-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.hero-two-col .hero-badge {
  align-self: flex-start;
}

.hero-two-col .hero-title {
  text-align: left;
  margin: 0;
}

.hero-two-col .hero-desc {
  text-align: left;
}

.hero-two-col .hero-actions {
  justify-content: flex-start;
  margin: 8px 0 0 !important;
}

.hero-two-col .hero-langs {
  justify-content: flex-start;
}

.hero-visual-col {
  flex: 1 1 560px;
  max-width: 640px;
  width: 100%;
  align-self: stretch;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

/* Stacked showcase: schema top-left, project bottom-right, connected by kite line */
.vision-showcase.stacked {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1.3;
  min-height: 380px;
  max-height: 540px;
}

.stacked-schema,
.stacked-project {
  position: absolute;
  width: 38%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 2;
}

.stacked-schema {
  top: 40px;
  left: 14%;
}

.stacked-project {
  bottom: 40px;
  right: 0;
}

.vision-showcase.stacked .show-card {
  padding: 10px;
  border-radius: 12px;
}

.vision-showcase.stacked .pic-table-head {
  padding: 4px 7px;
  font-size: 9.5px;
}

.vision-showcase.stacked .pic-row {
  padding: 3px 7px;
  font-size: 9px;
}

.vision-showcase.stacked .pic-field-type {
  font-size: 8px;
}

.vision-showcase.stacked .diagram-tables {
  gap: 8px;
}

.vision-showcase.stacked .tree-card {
  font-size: 9.5px;
  padding: 10px 8px;
}

.vision-showcase.stacked .tree-row {
  padding: 2px 5px;
  font-size: 9.5px;
}

.vision-showcase.stacked .tree-label {
  font-size: 9.5px;
}

.vision-showcase.stacked .show-card.diagram-card,
.vision-showcase.stacked .show-card.tree-card,
.vision-showcase.stacked .show-card.api-card {
  min-height: 0;
  max-height: none;
}

.vision-showcase.stacked .tree-card {
  font-size: 11px;
  padding: 10px 8px;
}

.vision-showcase.stacked .tree-row {
  padding: 2px 6px;
}

.vision-showcase.stacked .tree-label {
  font-size: 11px;
}

/* ===== Hero Showcase — Live demo (schema → API on one screen) ===== */
.hero-showcase {
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.hs-window {
  width: 100%;
  border-radius: 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 20px 60px -10px rgba(0, 0, 0, 0.25),
    0 8px 20px -4px rgba(74, 144, 217, 0.1);
  overflow: hidden;
  animation: hs-float 6s ease-in-out infinite;
}

@keyframes hs-float {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-4px); }
}

.hs-window-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 11px 14px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.05), transparent);
  border-bottom: 1px solid var(--border-color);
}

.hs-dots {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.hs-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.hs-dot.red    { background: #ff5f57; }
.hs-dot.yellow { background: #febc2e; }
.hs-dot.green  { background: #28c840; }

.hs-bar-title {
  flex: 1 1;
  text-align: center;
  font-size: 11.5px;
  color: var(--text-secondary);
  font-weight: 600;
  font-family: 'Consolas', 'Monaco', monospace;
}

.hs-bar-spacer {
  width: 56px;
  flex-shrink: 0;
}

/* ===== Split body: canvas + API side by side ===== */
.hs-split {
  display: flex;
  height: 360px;
  background: var(--bg-primary);
}

.hs-canvas,
.hs-api {
  position: relative;
  height: 100%;
  padding: 14px 16px;
  overflow: hidden;
}

.hs-canvas {
  flex: 1.2 1;
  border-right: 1px solid var(--border-color);
}

.hs-api {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.hs-side-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 10px;
  position: relative;
  z-index: 5;
}

.hs-side-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent);
}

.hs-side-dot.live {
  background: #2ea043;
  animation: hs-pulse 2s ease-in-out infinite;
}

/* ===== Canvas grid background ===== */
.hs-canvas-grid {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, var(--border-color) 1px, transparent 1px);
  background-size: 16px 16px;
  opacity: 0.35;
  pointer-events: none;
}

/* ===== Tables ===== */
.hs-tables {
  position: relative;
  z-index: 2;
  height: calc(100% - 28px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 6px 28px 6px 4px;
}

.hs-table {
  background: var(--bg-secondary);
  border: 1.5px solid var(--accent);
  border-radius: 8px;
  width: 150px;
  font-size: 10.5px;
  box-shadow: 0 4px 14px rgba(74, 144, 217, 0.15);
}

.hs-table-head {
  background: rgba(74, 144, 217, 0.2);
  color: var(--accent);
  font-weight: 700;
  padding: 5px 10px;
  border-radius: 7px 7px 0 0;
  font-size: 11px;
  letter-spacing: 0.3px;
}

.hs-table-row {
  display: flex;
  justify-content: space-between;
  padding: 3px 10px;
  border-top: 1px solid var(--border-color);
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 10px;
}

.hs-table-row.fk {
  color: #f0ad4e;
}

.hs-field-name {
  color: var(--text-primary);
}

.hs-field-type {
  color: var(--text-secondary);
}

/* ===== Relation line (static) ===== */
.hs-relation {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

/* ===== Right side: Live API output ===== */
.hs-url-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 11px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  margin-bottom: 12px;
}

.hs-globe {
  color: var(--text-secondary);
  display: inline-flex;
}

.hs-url {
  flex: 1 1;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 11px;
  color: var(--text-primary);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hs-live {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.6px;
  color: #2ea043;
  padding: 2px 7px;
  background: rgba(46, 160, 67, 0.12);
  border-radius: 9px;
}

.hs-live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2ea043;
  animation: hs-pulse 2s ease-in-out infinite;
}

@keyframes hs-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(46, 160, 67, 0.5); }
  50%      { box-shadow: 0 0 0 5px rgba(46, 160, 67, 0); }
}

.hs-endpoints {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  z-index: 2;
}

.hs-endpoint {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  background: var(--bg-secondary);
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 11px;
  transition: transform 0.15s, background 0.15s;
}

.hs-endpoint:hover {
  background: var(--bg-primary);
  transform: translateX(2px);
}

.hs-method {
  display: inline-block;
  min-width: 40px;
  text-align: center;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.4px;
}

.hs-method.get    { background: rgba(74, 144, 217, 0.18);  color: #4a90d9; }
.hs-method.post   { background: rgba(46, 160, 67, 0.18);   color: #2ea043; }
.hs-method.put    { background: rgba(240, 173, 78, 0.18);  color: #f0ad4e; }
.hs-method.delete { background: rgba(248, 81, 73, 0.18);   color: #f85149; }

.hs-path {
  color: var(--text-primary);
  flex: 1 1;
}

.hs-caption {
  font-size: 14px;
  color: var(--text-secondary);
  text-align: center;
  margin: 0;
  max-width: 460px;
  line-height: 1.5;
}

/* Responsive: stack vertically on smaller screens */
@media (max-width: 768px) {
  .hero-showcase { max-width: 100%; }
  .hs-split {
    flex-direction: column;
    height: auto;
  }
  .hs-canvas {
    flex: none;
    height: 240px;
    border-right: none;
    border-bottom: 1px solid var(--border-color);
  }
  .hs-api {
    flex: none;
    padding: 12px 14px 16px;
  }
  .hs-table { width: 130px; }
  .hs-caption { font-size: 13px; }
}

/* ===== Live API Card (replaces project tree) ===== */
.api-card {
  padding: 0 !important;
  overflow: hidden;
}

.api-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(74, 144, 217, 0.06);
  border-bottom: 1px solid var(--border-color);
}

.api-globe {
  display: inline-flex;
  color: var(--text-secondary);
}

.api-url {
  flex: 1 1;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 11px;
  color: var(--text-primary);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.api-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #2ea043;
}

.api-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2ea043;
  box-shadow: 0 0 0 2px rgba(46, 160, 67, 0.2);
  animation: api-pulse 2s ease-in-out infinite;
}

@keyframes api-pulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 2px rgba(46, 160, 67, 0.2); }
  50%      { opacity: 0.7; box-shadow: 0 0 0 4px rgba(46, 160, 67, 0.1); }
}

.api-card-body {
  padding: 6px 0;
  display: flex;
  flex-direction: column;
}

.api-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 10.5px;
}

.api-method {
  display: inline-block;
  min-width: 38px;
  text-align: center;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.3px;
}

.api-method.get {
  background: rgba(74, 144, 217, 0.18);
  color: #4a90d9;
}

.api-method.post {
  background: rgba(46, 160, 67, 0.18);
  color: #2ea043;
}

.api-method.put {
  background: rgba(240, 173, 78, 0.18);
  color: #f0ad4e;
}

.api-method.delete {
  background: rgba(248, 81, 73, 0.18);
  color: #f85149;
}

.api-path {
  color: var(--text-primary);
  flex: 0 1 auto;
}

.api-label {
  margin-left: auto;
  font-family: inherit;
  font-size: 9.5px;
  color: var(--text-secondary);
  font-style: italic;
}

.api-divider {
  height: 1px;
  background: var(--border-color);
  margin: 4px 12px;
  opacity: 0.5;
}

.vision-showcase.stacked .api-row {
  font-size: 10.5px;
  padding: 4px 12px;
}

.vision-showcase.stacked .api-url {
  font-size: 11px;
}

.stacked-line {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  opacity: 0.8;
}

/* Responsive: stack vertically on small screens */
@media (max-width: 900px) {
  .landing-hero.hero-two-col {
    flex-direction: column;
    gap: 32px;
    padding: 40px 20px;
    text-align: center;
    align-items: stretch;
  }
  .hero-text-col {
    max-width: 100%;
    padding: 0;
    align-items: center;
  }
  .hero-text-main {
    align-items: center;
    text-align: center;
  }
  .hero-two-col .hero-badge {
    align-self: center;
  }
  .hero-two-col .hero-title,
  .hero-two-col .hero-desc {
    text-align: center;
  }
  .hero-two-col .hero-actions,
  .hero-two-col .hero-langs {
    justify-content: center;
  }
  .hero-visual-col {
    max-width: 100%;
    align-self: auto;
    align-items: stretch;
  }

  /* Stacked showcase becomes vertical stack on mobile — left-aligned, compact */
  .vision-showcase.stacked {
    aspect-ratio: auto;
    min-height: auto;
    max-height: none;
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: flex-start;
    padding-left: 4px;
    padding-right: 20px;
  }
  .stacked-schema,
  .stacked-project {
    position: static;
    width: 100%;
    max-width: 300px;
    min-width: 0;
    top: auto;
    left: auto;
    bottom: auto;
    right: auto;
  }
  .stacked-line {
    display: none;
  }

  /* Smaller text inside cards on mobile */
  .vision-showcase.stacked .show-card {
    padding: 8px;
  }
  .vision-showcase.stacked .pic-table-head {
    padding: 3px 6px;
    font-size: 8.5px;
  }
  .vision-showcase.stacked .pic-row {
    padding: 2px 6px;
    font-size: 8px;
  }
  .vision-showcase.stacked .pic-field-type {
    font-size: 7px;
  }
  .vision-showcase.stacked .tree-card,
  .vision-showcase.stacked .tree-row,
  .vision-showcase.stacked .tree-label {
    font-size: 8.5px;
  }
  .vision-showcase.stacked .tree-card {
    padding: 8px 6px;
  }
}

/* Hide desktop nav actions on mobile, show hamburger only */
@media (max-width: 768px) {
  .landing-nav-actions .lang-switcher,
  .landing-nav-actions .menu-icon-btn,
  .landing-nav-actions .landing-btn-primary {
    display: none;
  }

  .mobile-nav-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 4px;
  }

  .mobile-nav-row .lang-switcher {
    display: flex;
  }

  .mobile-nav-row .menu-icon-btn {
    display: flex;
  }
}

.hero-badge {
  padding: 6px 16px;
  background: rgba(74, 144, 217, 0.1);
  border: 1px solid rgba(74, 144, 217, 0.2);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  letter-spacing: 0.5px;
}

.hero-title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -1px;
  color: var(--text-primary);
}

.hero-highlight {
  background: linear-gradient(135deg, var(--accent), #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-desc {
  font-size: 17px;
  color: var(--text-secondary);
  max-width: 560px;
  line-height: 1.6;
}

.hero-actions {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.hero-btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

.hero-btn-primary:hover {
  background: var(--accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(74, 144, 217, 0.3);
}

.hero-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: transparent;
  color: var(--text-primary);
  border: 1.5px solid var(--border-color);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.hero-btn-secondary:hover {
  border-color: var(--accent);
  color: var(--accent);
  transform: translateY(-1px);
}

.hero-btn-outline {
  padding: 12px 28px;
  background: none;
  border: 1.5px solid var(--border-color);
  border-radius: 10px;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.hero-btn-outline:hover {
  border-color: var(--accent);
  color: var(--accent);
}

/* Features */
.landing-features {
  display: flex;
  gap: 24px;
  padding: 60px 40px 80px;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
}

.feature-card {
  flex: 1 1;
  padding: 28px 24px;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  background: var(--bg-secondary);
  transition: all 0.2s;
}

.feature-card:hover {
  border-color: var(--accent);
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
}

.feature-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(74, 144, 217, 0.1);
  border-radius: 12px;
  color: var(--accent);
  margin-bottom: 16px;
}

.feature-card h3 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--text-primary);
}

.feature-card p {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.6;
}

/* Nav links */
.landing-nav-links {
  display: flex;
  gap: 4px;
}

.nav-link {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.15s;
}

.nav-link:hover {
  color: var(--text-primary);
  background: var(--bg-primary);
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  padding: 4px;
}

.mobile-nav-dropdown {
  display: none;
  flex-direction: column;
  padding: 8px 16px 16px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
}

.mobile-nav-link {
  background: none;
  border: none;
  text-align: left;
  padding: 10px 12px;
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s;
}

.mobile-nav-link:hover {
  background: var(--bg-primary);
}

.mobile-nav-link.accent {
  color: var(--accent);
  font-weight: 600;
}

.mobile-nav-divider {
  height: 1px;
  background: var(--border-color);
  margin: 4px 0;
}

/* Hero lang tags */
.hero-langs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}

.hero-lang-tag {
  padding: 4px 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
}

.hero-lang-tag.more {
  color: var(--accent);
  border-color: var(--accent);
  background: rgba(74, 144, 217, 0.05);
}

/* Sections */
.landing-section {
  padding: 80px 40px;
  max-width: 1100px;
  margin: 0 auto;
}

.landing-section.alt-bg {
  max-width: 100%;
  background: var(--bg-secondary);
}

.landing-section.alt-bg > * {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-badge {
  display: inline-block;
  padding: 4px 14px;
  background: rgba(74, 144, 217, 0.1);
  border: 1px solid rgba(74, 144, 217, 0.15);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  margin-bottom: 12px;
}

.section-title {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 12px;
}

.section-desc {
  font-size: 15px;
  color: var(--text-secondary);
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.6;
}

/* How it works */
.how-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
}

.how-step {
  flex: 1 1;
  max-width: 280px;
  text-align: center;
  padding: 24px 16px;
}

.how-step-num {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 800;
  margin-bottom: 16px;
}

.how-step-visual {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.how-step h3 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}

.how-step p {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.how-step-arrow {
  display: flex;
  align-items: center;
  padding-top: 100px;
}

/* Features grid v2 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.feature-card-v2 {
  padding: 24px;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  background: var(--bg-primary);
  transition: all 0.2s;
}

.feature-card-v2:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.feature-card-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 14px;
}

.feature-card-v2 h3 {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 6px;
}

.feature-card-v2 p {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.6;
}

/* Who grid */
.who-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.who-card {
  padding: 28px 20px;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  background: var(--bg-secondary);
  text-align: center;
  transition: all 0.2s;
}

.who-card:hover {
  border-color: var(--accent);
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.who-emoji {
  font-size: 32px;
  display: block;
  margin-bottom: 12px;
}

.who-card h3 {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 6px;
}

.who-card p {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.6;
}

/* Contact */
.contact-cards {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.contact-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 40px;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  background: var(--bg-primary);
  text-decoration: none;
  transition: all 0.2s;
  min-width: 240px;
}

.contact-card:hover {
  border-color: var(--accent);
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.contact-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  margin-bottom: 4px;
}

.email-icon {
  background: rgba(74, 144, 217, 0.1);
  color: var(--accent);
}

.tg-icon {
  background: rgba(46, 160, 67, 0.1);
  color: #2ea043;
}

.contact-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-secondary);
  font-weight: 600;
}

.contact-value {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 600;
}

/* CTA */
.landing-cta {
  text-align: center;
  padding: 80px 40px;
}

.landing-cta h2 {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 12px;
}

.landing-cta p {
  font-size: 16px;
  color: var(--text-secondary);
  margin-bottom: 24px;
}

.landing-cta .hero-btn-primary {
  display: inline-flex;
}

/* Footer v2 */
.landing-footer-v2 {
  border-top: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.footer-content {
  display: flex;
  gap: 60px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 48px 40px 32px;
}

.footer-brand {
  flex: 1 1;
}

.footer-brand p {
  font-size: 13px;
  color: var(--text-secondary);
  margin-top: 8px;
  line-height: 1.5;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-links h4 {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.footer-links button,
.footer-links a {
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  padding: 2px 0;
  transition: color 0.15s;
}

.footer-links button:hover,
.footer-links a:hover {
  color: var(--accent);
}

.footer-bottom {
  border-top: 1px solid var(--border-color);
  padding: 16px 40px;
  text-align: center;
  max-width: 1100px;
  margin: 0 auto;
}

.footer-bottom p {
  font-size: 12px;
  color: var(--text-secondary);
}

/* Scroll to top */
.scroll-top-btn {
  position: fixed;
  bottom: 28px;
  right: 28px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 500;
  opacity: 0;
  transform: translateY(20px) scale(0.8);
  pointer-events: none;
  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 4px 16px rgba(74, 144, 217, 0.3);
}

.scroll-top-btn.visible {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

.scroll-top-btn:hover {
  transform: translateY(-3px) scale(1.08);
  box-shadow: 0 6px 24px rgba(74, 144, 217, 0.4);
}

.scroll-top-btn:active {
  transform: translateY(0) scale(0.95);
}

/* ===== Home / Dashboard ===== */
/* ===== Dashboard Sidebar ===== */
.dash-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.dash-sidebar {
  width: 220px;
  min-width: 220px;
  background: var(--bg-secondary);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  position: relative;
  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
              min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.dash-sidebar:not(.open) {
  width: 48px;
  min-width: 48px;
  border-right: 1px solid var(--border-color);
}

.dash-sidebar-nav {
  flex: 1 1;
  padding: 16px 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  white-space: nowrap;
}

.dash-nav-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dash-nav-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-secondary);
  padding: 0 12px;
  margin-bottom: 6px;
}

.dash-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.12s;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
}

.dash-nav-item:hover {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.dash-nav-item.active {
  background: rgba(74, 144, 217, 0.1);
  color: var(--accent);
  font-weight: 600;
}

.dash-nav-item.new-project {
  color: var(--accent);
  font-weight: 600;
}

.dash-nav-item.new-project:hover {
  background: rgba(74, 144, 217, 0.1);
}

.dash-nav-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-nav-badge {
  margin-left: auto;
  padding: 2px 6px;
  background: linear-gradient(135deg, var(--accent), #8250df);
  color: #fff;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.8px;
  border-radius: 4px;
  flex-shrink: 0;
}

.dash-sidebar-header {
  display: flex;
  justify-content: flex-end;
  padding: 10px 10px 0;
}

.dash-sidebar-toggle {
  width: 28px;
  height: 28px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  padding: 0;
  flex-shrink: 0;
}

.dash-sidebar-toggle:hover {
  border-color: var(--accent);
  color: var(--accent);
}

/* Collapsed sidebar */
.dash-sidebar:not(.open) .dash-sidebar-header {
  justify-content: center;
  padding: 10px 0 0;
}

.dash-sidebar:not(.open) .dash-sidebar-nav {
  padding: 12px 6px;
  align-items: center;
}

.dash-sidebar:not(.open) .dash-nav-label {
  display: none;
}

.dash-sidebar:not(.open) .dash-nav-text,
.dash-sidebar:not(.open) .dash-nav-badge {
  display: none;
}

.dash-sidebar:not(.open) .dash-nav-item {
  justify-content: center;
  padding: 9px;
  width: 36px;
  gap: 0;
}

.dash-main {
  flex: 1 1;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.home-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.home-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 40px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.home-nav-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Profile Button & Menu */
.profile-wrapper {
  position: relative;
}

.profile-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid var(--border-color);
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.profile-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
  transform: scale(1.05);
}

.admin-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid var(--border-color);
  background: var(--bg-primary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.admin-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
  transform: scale(1.05);
}

.admin-btn.active {
  border-color: var(--accent);
  color: var(--accent);
  background: rgba(74, 144, 217, 0.08);
}

/* ===== Admin Page ===== */
.admin-page {
  padding: 24px 32px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.admin-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
}

.admin-signout-btn {
  padding: 8px 14px;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.admin-signout-btn:hover {
  color: var(--danger);
  border-color: var(--danger);
}

.admin-locked {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 60px 20px;
  color: var(--text-secondary);
  text-align: center;
}

.admin-locked .auth-submit {
  width: auto;
  padding: 10px 24px;
}

.admin-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid var(--border-color);
  margin-bottom: 16px;
}

.admin-tab {
  padding: 10px 18px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
}

.admin-tab:hover {
  color: var(--text-primary);
}

.admin-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.admin-table-wrap {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  overflow: hidden;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.admin-table thead {
  background: var(--bg-primary);
}

.admin-table th {
  text-align: left;
  padding: 12px 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border-color);
}

.admin-table td {
  padding: 12px 16px;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-color);
}

.admin-table tbody tr:last-child td {
  border-bottom: none;
}

.admin-table tbody tr:hover {
  background: var(--dropdown-hover);
}

.admin-table .admin-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* ===== Read-only editor ===== */
.side-menu.read-only input,
.side-menu.read-only select,
.side-menu.read-only textarea,
.side-menu.read-only .auto-gen-btn,
.side-menu.read-only input[type="checkbox"] {
  pointer-events: none;
  opacity: 0.7;
  -webkit-user-select: none;
          user-select: none;
}

.admin-view-banner {
  position: fixed;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  padding: 8px 18px;
  background: rgba(74, 144, 217, 0.12);
  border: 1px solid var(--accent);
  border-radius: 999px;
  color: var(--accent);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
}

.admin-view-banner svg {
  width: 14px;
  height: 14px;
}

.admin-view-btn {
  padding: 6px 12px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.admin-view-btn:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.admin-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.admin-badge.ok {
  background: rgba(76, 175, 80, 0.12);
  color: #4CAF50;
}

.admin-badge.warn {
  background: rgba(248, 81, 73, 0.12);
  color: var(--danger);
}

.admin-loading,
.admin-empty {
  padding: 40px 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 13px;
}

.admin-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 16px;
  border-top: 1px solid var(--border-color);
  flex-wrap: wrap;
}

.admin-pager-left,
.admin-pager-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.admin-pager-size {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 600;
}

.admin-pager-size select {
  padding: 5px 8px;
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.admin-pager-size select:focus {
  outline: none;
  border-color: var(--accent);
}

.home-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-top: 28px;
  padding: 16px;
}

/* ===== Poster Page (for social media screenshots) ===== */
.poster-page {
  /* poster-specific accents */
  --poster-accent: #58a6ff;
  --poster-accent-2: #b392f0;
  --poster-surface: rgba(32, 42, 62, 0.92);
  --poster-border: rgba(88, 166, 255, 0.55);
  --poster-text: #e6edf3;
  --poster-text-dim: rgba(230, 237, 243, 0.6);

  /* override global theme vars so VisionShowcase adopts dark poster palette */
  --bg-primary: #0d1117;
  --bg-secondary: rgba(22, 27, 34, 0.72);
  --border-color: rgba(88, 166, 255, 0.22);
  --text-primary: #e6edf3;
  --text-secondary: rgba(230, 237, 243, 0.6);
  --accent: #58a6ff;
  --accent-hover: #79b8ff;
  --node-header: rgba(88, 166, 255, 0.3);
  --node-header-text: #a4c9ff;
  --node-field-alt: rgba(88, 166, 255, 0.05);
  --node-border: rgba(88, 166, 255, 0.18);
  --dropdown-hover: rgba(88, 166, 255, 0.08);
  --popup-bg: rgba(22, 27, 34, 0.85);

  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: radial-gradient(ellipse at top left, #1a2540 0%, #0d1117 45%, #05080e 100%);
  color: var(--poster-text);
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  padding: 24px 44px;
  box-sizing: border-box;
}

.poster-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  pointer-events: none;
  z-index: 0;
}

.poster-blob-1 {
  top: -140px;
  left: -100px;
  width: 520px;
  height: 520px;
  background: radial-gradient(circle, rgba(88, 166, 255, 0.28) 0%, transparent 70%);
}

.poster-blob-2 {
  bottom: -180px;
  right: -140px;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(179, 146, 240, 0.22) 0%, transparent 70%);
}

.poster-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Title row at top (single line) */
.poster-title-row {
  position: relative;
  z-index: 1;
  margin: 14px 0 0;
  padding: 0;
  font-size: clamp(26px, 3vw, 48px);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  color: var(--poster-text);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  flex-shrink: 0;
}

.poster-title-accent {
  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Main area: stacked showcase (left, dominant) + compact checklist (right) */
.poster-main-v3 {
  position: relative;
  z-index: 1;
  flex: 1 1;
  display: grid;
  grid-template-columns: 2fr 0.65fr;
  gap: 27px;
  align-items: stretch;
  min-height: 0;
  padding: 20px 0;
}

/* Right column: checklist on top, Try it CTA at bottom */
.poster-right-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 0;
  margin-right: 56px;
  padding-top: 2%;
}

.poster-right-col .poster-checklist {
  margin-right: 0;
}

.poster-showcase-col {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

/* "1 click" badge at the start of the kite line (just after schema) */
.poster-click-badge {
  position: absolute;
  top: 13%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  color: #fff;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-shadow:
    0 6px 18px rgba(88, 166, 255, 0.4),
    0 0 0 4px rgba(88, 166, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.22);
  z-index: 3;
  white-space: nowrap;
}

.poster-click-badge svg {
  width: 12px;
  height: 12px;
  color: #fff176;
  filter: drop-shadow(0 0 3px rgba(255, 241, 118, 0.75));
}

.poster-showcase-col .vision-showcase.stacked {
  max-width: none;
  width: 100%;
  height: 100%;
  aspect-ratio: auto;
  max-height: none;
  min-height: 0;
}

/* Cards sized for poster — schema narrower/higher, project bigger/lower */
.poster-showcase-col .stacked-schema {
  width: 32%;
  top: 2%;
}

.poster-showcase-col .stacked-project {
  width: 34%;
  right: 8%;
  bottom: 0;
}

.poster-showcase-col .show-card {
  background: #e9eef5;
  border: 1px solid rgba(148, 163, 184, 0.4);
  box-shadow:
    0 24px 56px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(255, 255, 255, 0.04);
  padding: 18px;
}

/* Schema table text — readable on screenshots */
.poster-showcase-col .vision-showcase.stacked .pic-table {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
}

.poster-showcase-col .vision-showcase.stacked .pic-table-head {
  padding: 10px 14px;
  font-size: 17px;
  font-weight: 800;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: #ffffff;
  letter-spacing: 0.3px;
  border-bottom: none;
}

.poster-showcase-col .vision-showcase.stacked .pic-row {
  padding: 8px 14px;
  font-size: 15px;
}

.poster-showcase-col .vision-showcase.stacked .pic-row:nth-child(odd) {
  background: #f8fafc;
}

.poster-showcase-col .vision-showcase.stacked .pic-field-name {
  color: #0f172a;
  font-weight: 600;
}

.poster-showcase-col .vision-showcase.stacked .pic-row.is-key .pic-field-name {
  color: #d97706;
  font-weight: 800;
}

.poster-showcase-col .vision-showcase.stacked .pic-row.is-fk .pic-field-name {
  color: #e11d48;
  font-weight: 700;
}

.poster-showcase-col .vision-showcase.stacked .pic-field-type {
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
}

/* Schema tables layout: User + Comment on top row, Post centered below */
.poster-showcase-col .vision-showcase.stacked .diagram-tables {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "user comment"
    "post post";
  gap: 26px 22px;
  align-items: start;
  width: 100%;
}

.poster-showcase-col .vision-showcase.stacked .diagram-tables > .pic-table:nth-child(1) {
  grid-area: user;
  width: 100%;
  align-self: auto;
}

.poster-showcase-col .vision-showcase.stacked .diagram-tables > .pic-table:nth-child(2) {
  grid-area: post;
  width: 60%;
  justify-self: center;
  align-self: auto;
}

.poster-showcase-col .vision-showcase.stacked .diagram-tables > .pic-table:nth-child(3) {
  grid-area: comment;
  width: 100%;
  align-self: auto;
}

/* Project tree — bright card */
.poster-showcase-col .vision-showcase.stacked .tree-card {
  font-size: 15px;
  padding: 16px 14px;
  background: #e9eef5;
  border: 1px solid rgba(148, 163, 184, 0.4);
  color: #0f172a;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
}

.poster-showcase-col .vision-showcase.stacked .tree-row {
  padding: 4px 6px;
  font-size: 15px;
  color: #0f172a;
}

.poster-showcase-col .vision-showcase.stacked .tree-row.accent {
  color: #8b5cf6;
  font-weight: 700;
}

.poster-showcase-col .vision-showcase.stacked .tree-label {
  font-size: 15px;
}

.poster-showcase-col .vision-showcase.stacked .tree-icon.folder {
  color: #3b82f6;
}

.poster-showcase-col .vision-showcase.stacked .tree-icon.file {
  color: #94a3b8;
}

.poster-showcase-col .vision-showcase.stacked .show-label {
  font-size: 13px;
  letter-spacing: 1.2px;
  margin-bottom: 12px;
  color: rgba(230, 237, 243, 0.8);
  font-weight: 700;
}

.poster-showcase-col .vision-showcase.stacked .show-card {
  padding: 16px;
}

/* ----- Checklist column — pill/chip layout (not table-like) ----- */
.poster-checklist {
  padding: 8px 4px;
  margin-right: 56px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-content: center;
}

.poster-checklist-title {
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 3px;
  text-transform: uppercase;
  position: relative;
  padding-left: 18px;
  background: linear-gradient(135deg, #79b8ff 0%, #c49dff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.poster-checklist-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);
  box-shadow: 0 0 16px rgba(88, 166, 255, 0.9);
}

.poster-checklist-items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.poster-check-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 8px 10px;
  background: #e9eef5;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 999px;
  font-size: 13px;
  color: #0f172a;
  font-weight: 700;
  transition: none;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}

.poster-check-box {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.5);
}

.poster-check-box svg {
  width: 10px;
  height: 10px;
}

.poster-check-label {
  line-height: 1;
  letter-spacing: 0.2px;
}

/* ----- Footer CTA (inside right column) ----- */
.poster-footer-cta {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 9px 18px;
  background: rgba(88, 166, 255, 0.1);
  border: 1px solid rgba(88, 166, 255, 0.32);
  border-radius: 999px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(88, 166, 255, 0.2);
}

.poster-footer-try {
  font-size: 16px;
  font-weight: 700;
  color: rgba(230, 237, 243, 0.9);
  letter-spacing: 0.3px;
}

.poster-footer-hand {
  font-size: 19px;
  line-height: 1;
  filter: drop-shadow(0 0 5px rgba(88, 166, 255, 0.5));
}

.poster-footer-domain {
  font-family: 'Fira Code', 'SF Mono', Menlo, Consolas, monospace;
  font-size: 17px;
  font-weight: 800;
  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
}

/* ===== Templates Page ===== */
.templates-standalone {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
}

.templates-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 32px;
  border-bottom: 1px solid var(--border-color);
}

.templates-nav-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.templates-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 32px 40px;
  width: 100%;
}

.templates-hero {
  text-align: center;
  margin-bottom: 28px;
}

.templates-hero-title {
  font-size: clamp(26px, 3vw, 38px);
  font-weight: 800;
  letter-spacing: -0.02em;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 8px;
  line-height: 1.1;
}

.templates-hero-sub {
  font-size: clamp(13px, 1.1vw, 16px);
  color: var(--text-secondary);
  max-width: 560px;
  margin: 0 auto;
  line-height: 1.5;
}

.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
}

.template-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 14px;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
}

.template-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, transparent, currentColor, transparent);
  opacity: 0;
  transition: opacity 0.2s;
}

.template-card:hover {
  transform: translateY(-3px);
  border-color: var(--accent);
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.16);
}

.template-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.template-card-icon svg {
  width: 26px;
  height: 26px;
}

.template-card-name {
  font-size: 19px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.01em;
  margin: 0;
}

.template-card-desc {
  font-size: 14px;
  line-height: 1.55;
  color: var(--text-secondary);
  margin: 0;
}

.template-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
}

.template-meta-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-secondary);
}

.template-card-features {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.template-feature-chip {
  padding: 4px 10px;
  background: rgba(74, 144, 217, 0.1);
  border: 1px solid rgba(74, 144, 217, 0.25);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--accent);
}

.template-card-cta {
  padding: 9px 16px;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 0.2px;
}

.template-card-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  filter: brightness(1.05);
}

/* ===== Custom template badge in TemplatesPage ===== */
.template-custom-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  background: rgba(240, 173, 78, 0.15);
  border: 1px solid rgba(240, 173, 78, 0.4);
  border-radius: 999px;
  color: #f0ad4e;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  vertical-align: middle;
}

/* ===== Admin Templates ===== */
.admin-templates-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
}

/* ===== Template Editor (admin) ===== */
.template-editor-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.template-editor-back {
  width: 30px;
  height: 30px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.template-editor-back:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.template-editor-fields {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.template-editor-input {
  padding: 7px 12px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  flex: 0 0 200px;
  transition: border-color 0.15s;
}

.template-editor-input.wide {
  flex: 1 1 auto;
  font-weight: 500;
}

.template-editor-input:focus {
  outline: none;
  border-color: var(--accent);
}

.template-editor-color {
  width: 32px;
  height: 32px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: none;
  cursor: pointer;
  padding: 2px;
}

.template-editor-select {
  padding: 7px 10px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

.template-editor-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.template-editor-saved {
  font-size: 12px;
  font-weight: 600;
  color: #2ea043;
}

.template-editor-error {
  font-size: 12px;
  font-weight: 600;
  color: var(--danger);
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.template-editor-save {
  padding: 8px 18px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}

.template-editor-save:hover:not(:disabled) {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.template-editor-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.template-editor-main {
  height: calc(100vh - 52px);
}

/* Push floating + Table / + Enum buttons below the template editor top bar */
.template-editor-page .floating-add-buttons {
  top: 64px;
}

/* ===== Guest Viewer Banner ===== */
.guest-banner {
  position: fixed;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 16px 10px 18px;
  background: var(--popup-bg);
  border: 1px solid var(--accent);
  border-radius: 999px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
}

.guest-banner-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.guest-banner-text svg {
  color: var(--accent);
}

.guest-banner-cta {
  padding: 6px 14px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}

.guest-banner-cta:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

/* ===== Editor Toast ===== */
.editor-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background: var(--popup-bg);
  color: var(--text-primary);
  border: 1px solid var(--danger);
  border-left: 4px solid var(--danger);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  animation: toastSlideIn 0.25s ease-out, toastFadeOut 0.35s ease-in 3.15s forwards;
  max-width: 92vw;
}

.editor-toast svg {
  flex-shrink: 0;
  color: var(--danger);
}

@keyframes toastSlideIn {
  from { opacity: 0; transform: translate(-50%, -12px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}

@keyframes toastFadeOut {
  from { opacity: 1; transform: translate(-50%, 0); }
  to { opacity: 0; transform: translate(-50%, -12px); }
}

/* ===== Vision Page (single viewport) ===== */
.vision-single {
  height: 100vh;
  overflow: hidden;
  background: var(--bg-primary);
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.vision-nav-thin {
  flex-shrink: 0;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  border-bottom: 1px solid var(--border-color);
}

.vision-cta-small {
  padding: 7px 14px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.vision-cta-small:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.vision-stage {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
  gap: 28px;
  min-height: 0;
}

.vision-heading {
  text-align: center;
  flex-shrink: 0;
}

.vision-big-title {
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.05;
  margin-bottom: 8px;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.vision-big-sub {
  font-size: clamp(14px, 1.4vw, 18px);
  color: var(--text-secondary);
  font-weight: 500;
}

.vision-showcase {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(20px, 4vw, 48px);
  width: 100%;
  max-width: 1280px;
  min-height: 0;
}

.show-side {
  flex: 1 1;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  min-height: 0;
}

.show-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--text-secondary);
  text-align: center;
}

.show-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
  padding: 18px;
  position: relative;
  overflow: hidden;
}

.diagram-card {
  min-height: 320px;
}

.diagram-tables {
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;
  z-index: 1;
}

.diagram-tables > .pic-table:nth-child(1) { align-self: flex-start; width: 62%; }
.diagram-tables > .pic-table:nth-child(2) { align-self: center; width: 68%; }
.diagram-tables > .pic-table:nth-child(3) { align-self: flex-end; width: 58%; }

.pic-table {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.pic-table-head {
  padding: 6px 10px;
  background: var(--node-header);
  color: var(--node-header-text);
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.2px;
  border-bottom: 1px solid var(--border-color);
}

.pic-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  font-size: 11.5px;
}

.pic-row:nth-child(odd) {
  background: var(--node-field-alt);
}

.pic-field-name {
  color: var(--text-primary);
  font-weight: 500;
}

.pic-field-type {
  color: var(--text-secondary);
  font-family: 'Fira Code', 'SF Mono', Menlo, Consolas, monospace;
  font-size: 10.5px;
}

.pic-row.is-key .pic-field-name {
  color: var(--accent);
  font-weight: 700;
}

.pic-row.is-fk .pic-field-name {
  color: #f0ad4e;
  font-weight: 600;
}

.diagram-lines {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  opacity: 0.6;
}

.show-arrow {
  flex-shrink: 0;
  width: clamp(70px, 10vw, 130px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  color: var(--accent);
}

.show-arrow svg {
  width: 100%;
  height: auto;
  display: block;
}

.show-arrow-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--accent);
  line-height: 1;
}

.tree-card {
  font-family: 'Fira Code', 'SF Mono', Menlo, Consolas, monospace;
  font-size: 12.5px;
  padding: 14px 10px;
  min-height: 320px;
  max-height: 50vh;
  overflow: hidden;
}

.tree-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 6px;
  border-radius: 4px;
  white-space: nowrap;
  color: var(--text-primary);
}

.tree-row.accent {
  color: var(--accent);
  font-weight: 600;
}

.tree-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: var(--text-secondary);
}

.tree-icon.folder {
  color: var(--accent);
}

.tree-icon.file {
  color: var(--text-secondary);
}

.tree-label {
  font-size: 12px;
}

.vision-cta-row {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.vision-cta-big {
  padding: 14px 38px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 6px 22px rgba(74, 144, 217, 0.3);
}

.vision-cta-big:hover {
  background: var(--accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(74, 144, 217, 0.4);
}

.vision-cta-hint {
  font-size: 12px;
  color: var(--text-secondary);
  letter-spacing: 0.3px;
}

@media (max-width: 900px) {
  .vision-single { height: auto; min-height: 100vh; overflow: auto; }
  .vision-showcase { flex-direction: column; gap: 20px; }
  .show-arrow { width: 60px; transform: rotate(90deg); }
  .show-side { max-width: 100%; width: 100%; }
  .tree-card, .diagram-card { min-height: auto; }
}

.admin-page-btn {
  padding: 7px 14px;
  background: transparent;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.admin-page-btn:hover:not(:disabled) {
  border-color: var(--accent);
  color: var(--accent);
}

.admin-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.admin-page-info {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 600;
}

.admin-login-hint {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.5;
  margin-bottom: 4px;
}

.admin-resend-btn {
  align-self: center;
  background: none;
  border: none;
  color: var(--accent);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 8px;
}

.admin-resend-btn:disabled {
  color: var(--text-secondary);
  cursor: not-allowed;
}

.auth-info {
  padding: 8px 12px;
  background: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 8px;
  color: #4CAF50;
  font-size: 12px;
  font-weight: 500;
}

.profile-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.profile-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 200px;
  background: var(--popup-bg);
  border: 1px solid var(--border-color);
  border-radius: 14px;
  padding: 6px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  animation: slideDown 0.15s ease-out;
}

.profile-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.12s;
}

.profile-menu-item:hover {
  background: var(--bg-primary);
}

.profile-menu-item.danger {
  color: var(--danger);
}

.profile-menu-item.danger:hover {
  background: rgba(248, 81, 73, 0.08);
}

.profile-menu-divider {
  height: 1px;
  background: var(--border-color);
  margin: 4px 10px;
}

/* ===== Profile Page ===== */
.profile-content {
  max-width: 520px;
  margin: 0 auto;
  padding: 32px 40px;
}

.profile-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  margin-bottom: 24px;
  transition: color 0.15s;
}

.profile-back:hover {
  color: var(--accent);
}

.profile-title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 24px;
}

.profile-message {
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 20px;
  animation: slideDown 0.2s ease-out;
}

.profile-message.success {
  background: rgba(46, 160, 67, 0.1);
  border: 1px solid rgba(46, 160, 67, 0.25);
  color: #2ea043;
}

.profile-message.error {
  background: rgba(248, 81, 73, 0.1);
  border: 1px solid rgba(248, 81, 73, 0.25);
  color: #f85149;
}

.profile-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
}

.profile-card-title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 18px;
  color: var(--text-primary);
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.profile-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.profile-field label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-secondary);
}

.profile-field input {
  padding: 10px 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  transition: all 0.2s;
}

.profile-field input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);
}

.profile-divider {
  height: 1px;
  background: var(--border-color);
  margin: 6px 0;
}

.profile-card-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.profile-hint {
  font-size: 11px;
  color: var(--text-secondary);
  font-style: italic;
  margin-top: -4px;
}

/* Verification */
.profile-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.verify-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
}

.verify-badge.verified {
  color: #2ea043;
  background: rgba(46, 160, 67, 0.1);
}

.verify-badge.unverified {
  color: #f85149;
  background: rgba(248, 81, 73, 0.1);
}

.verify-prompt {
  margin-top: 6px;
  padding: 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  animation: slideDown 0.2s ease-out;
}

.verify-prompt-text {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.5;
  margin-bottom: 10px;
}

.verify-send-btn {
  padding: 8px 16px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.verify-send-btn:hover:not(:disabled) {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.verify-send-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.verify-code-box {
  margin-top: 6px;
  padding: 14px;
  background: var(--bg-primary);
  border: 1px solid var(--accent);
  border-radius: 10px;
  animation: slideDown 0.2s ease-out;
}

.verify-code-text {
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 10px;
}

.verify-code-row {
  display: flex;
  gap: 8px;
}

.verify-code-input {
  flex: 1 1;
  padding: 9px 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 4px;
  text-align: center;
}

.verify-code-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);
}

.verify-confirm-btn {
  padding: 9px 20px;
  background: #2ea043;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.verify-confirm-btn:hover:not(:disabled) {
  background: #278c38;
}

.verify-confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.verify-resend {
  background: none;
  border: none;
  color: var(--accent);
  font-size: 11px;
  cursor: pointer;
  margin-top: 8px;
  text-decoration: underline;
  padding: 0;
}

.verify-resend:hover {
  color: var(--accent-hover);
}

.verify-resend:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.verify-msg {
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  animation: slideDown 0.15s ease-out;
}

.verify-msg.success {
  background: rgba(46, 160, 67, 0.1);
  color: #2ea043;
}

.verify-msg.error {
  background: rgba(248, 81, 73, 0.1);
  color: #f85149;
}

.profile-save-btn {
  padding: 11px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 4px;
  align-self: flex-start;
  padding-left: 24px;
  padding-right: 24px;
}

.profile-save-btn:hover:not(:disabled) {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.3);
}

.profile-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.home-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 40px;
}

.home-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}

.home-title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.home-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin-top: 4px;
}

.home-new-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.home-new-btn:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(74, 144, 217, 0.3);
}

.home-tabs {
  display: flex;
  border-bottom: 2px solid var(--border-color);
  margin-bottom: 24px;
}

.home-tab {
  padding: 10px 20px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.home-tab:hover {
  color: var(--text-primary);
}

.home-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.home-loading {
  text-align: center;
  padding: 40px;
  color: var(--text-secondary);
}

.home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.home-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.home-empty p {
  margin-bottom: 16px;
  font-size: 15px;
}

.home-empty-btn {
  padding: 10px 24px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.home-empty-btn:hover {
  background: var(--accent-hover);
}

/* Project Cards */
.project-card {
  padding: 20px;
  border: 1px solid var(--border-color);
  border-radius: 14px;
  background: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.2s;
}

.project-card:hover {
  border-color: var(--accent);
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
}

.project-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.project-delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 50%;
  color: var(--text-secondary);
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s;
  padding: 0;
}

.project-card:hover .project-delete-btn {
  opacity: 0.5;
}

.project-delete-btn:hover {
  opacity: 1 !important;
  color: var(--danger);
  border-color: var(--danger);
  background: rgba(248, 81, 73, 0.1);
}

/* ===== Delete Confirm Modal ===== */
.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--popup-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.15s ease-out;
}

.confirm-modal {
  background: var(--popup-bg);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  width: 360px;
  padding: 32px 28px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.3);
  animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.confirm-icon {
  margin-bottom: 2px;
}

.confirm-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.confirm-desc {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.confirm-actions {
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
}

.confirm-cancel {
  flex: 1 1;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: transparent;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-cancel:hover {
  background: var(--bg-primary);
  border-color: var(--text-secondary);
}

.confirm-delete {
  flex: 1 1;
  padding: 10px;
  border: none;
  border-radius: 10px;
  background: #f85149;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-delete:hover:not(:disabled) {
  background: #da3633;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(248, 81, 73, 0.3);
}

.confirm-delete:disabled,
.confirm-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.project-card-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(74, 144, 217, 0.1);
  border-radius: 8px;
  color: var(--accent);
}

.draft-icon {
  background: rgba(240, 173, 78, 0.1);
  color: #f0ad4e;
}

.project-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.project-badge.active {
  background: rgba(46, 160, 67, 0.1);
  color: #2ea043;
}

.project-badge.expired {
  background: rgba(248, 81, 73, 0.1);
  color: #f85149;
}

.project-badge.draft {
  background: rgba(240, 173, 78, 0.1);
  color: #f0ad4e;
}

.project-card-name {
  font-size: 16px;
  font-weight: 700;
}

.project-card-date {
  font-size: 11px;
  color: var(--text-secondary);
}

.project-card-actions {
  margin-top: auto;
  padding-top: 6px;
}

.project-card-actions.two-actions {
  display: flex;
  gap: 6px;
}

.project-action-btn {
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  text-align: center;
}

.project-action-btn.download {
  background: rgba(46, 160, 67, 0.1);
  color: #2ea043;
  border: 1px solid rgba(46, 160, 67, 0.2);
}

.project-action-btn.download:hover {
  background: #2ea043;
  color: #fff;
}

.project-action-btn.edit {
  background: rgba(74, 144, 217, 0.1);
  color: var(--accent);
  border: 1px solid rgba(74, 144, 217, 0.2);
}

.project-action-btn.edit:hover {
  background: var(--accent);
  color: #fff;
}

/* ===== Feedback Banner Compact (Dashboard) ===== */
.feedback-banner-compact {
  padding: 12px 18px;
  background: linear-gradient(135deg, rgba(74, 144, 217, 0.06) 0%, rgba(130, 80, 223, 0.06) 100%);
  border: 1px solid rgba(74, 144, 217, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 20px;
}

.feedback-banner-compact:hover {
  background: linear-gradient(135deg, rgba(74, 144, 217, 0.1) 0%, rgba(130, 80, 223, 0.1) 100%);
  border-color: var(--accent);
}

.feedback-banner-compact:hover svg {
  transform: translateX(3px);
}

.feedback-banner-compact svg {
  color: var(--accent);
  flex-shrink: 0;
  transition: transform 0.2s;
}

.feedback-banner-compact .feedback-banner-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.feedback-banner-badge {
  padding: 3px 8px;
  background: linear-gradient(135deg, var(--accent), #8250df);
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1px;
  border-radius: 5px;
  flex-shrink: 0;
}

.feedback-banner-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-primary);
}

.feedback-banner-desc {
  font-size: 11px;
  color: var(--text-secondary);
}

/* ===== Feedback Page ===== */
.feedback-header {
  margin-bottom: 8px;
}

.feedback-form {
  margin-bottom: 24px;
  animation: slideDown 0.2s ease-out;
}

.feedback-form-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feedback-about-options {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.feedback-about-btn {
  padding: 7px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.feedback-about-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.feedback-about-btn.active {
  background: rgba(74, 144, 217, 0.1);
  border-color: var(--accent);
  color: var(--accent);
}

.feedback-textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
  transition: all 0.2s;
  box-sizing: border-box;
}

.feedback-textarea:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);
}

.feedback-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feedback-card {
  padding: 20px;
  border: 1px solid var(--border-color);
  border-radius: 14px;
  background: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.2s;
}

.feedback-card:hover {
  border-color: var(--accent);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0,0,0,0.05);
}

.feedback-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.feedback-about-tag {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.feedback-about-tag.platform {
  background: rgba(74, 144, 217, 0.1);
  color: var(--accent);
}

.feedback-about-tag.generated_project {
  background: rgba(46, 160, 67, 0.1);
  color: #2ea043;
}

.feedback-about-tag.other {
  background: rgba(240, 173, 78, 0.1);
  color: #f0ad4e;
}

.feedback-delete-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid transparent;
  border-radius: 50%;
  color: var(--text-secondary);
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s;
  padding: 0;
}

.feedback-card:hover .feedback-delete-btn {
  opacity: 0.5;
}

.feedback-delete-btn:hover {
  opacity: 1 !important;
  color: var(--danger);
  border-color: var(--danger);
  background: rgba(248, 81, 73, 0.1);
}

.feedback-card-text {
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-primary);
}

.feedback-card-date {
  font-size: 11px;
  color: var(--text-secondary);
}

.feedback-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
}

.feedback-page-btn {
  padding: 8px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.feedback-page-btn:hover:not(:disabled) {
  border-color: var(--accent);
  color: var(--accent);
}

.feedback-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.feedback-page-info {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

/* ===== Editor extras ===== */
.save-indicator {
  position: fixed;
  bottom: 16px;
  right: 16px;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  z-index: 500;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
}

.save-indicator.saving {
  opacity: 1;
  background: rgba(74, 144, 217, 0.15);
  color: var(--accent);
  border: 1px solid rgba(74, 144, 217, 0.3);
}

.save-indicator.saved {
  opacity: 1;
  background: rgba(46, 160, 67, 0.15);
  color: #2ea043;
  border: 1px solid rgba(46, 160, 67, 0.3);
}

.save-indicator.error {
  opacity: 1;
  background: rgba(248, 81, 73, 0.15);
  color: #f85149;
  border: 1px solid rgba(248, 81, 73, 0.3);
}

/* ===== Floating Add Buttons ===== */
.floating-add-buttons {
  position: fixed;
  top: 12px;
  right: 56px;
  display: flex;
  gap: 6px;
  z-index: 500;
}

/* Top-left project name input — shifts right when toolbar opens */
.floating-project-name {
  position: fixed;
  top: 12px;
  left: 56px;
  z-index: 500;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.floating-project-name.toolbar-open {
  left: 312px;
}

.floating-project-name-input {
  background: var(--bg-secondary);
  backdrop-filter: blur(12px);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  width: 200px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.floating-project-name-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 2px rgba(74, 144, 217, 0.15);
}

.floating-project-name-input::placeholder {
  color: var(--text-secondary);
  font-weight: 500;
}

@media (max-width: 768px) {
  .floating-project-name-input {
    width: 140px;
  }
}

.floating-add-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  background: var(--bg-secondary);
  backdrop-filter: blur(12px);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.floating-add-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
}

.floating-add-btn.enum {
  color: var(--text-secondary);
}

.floating-add-btn.enum:hover {
  border-color: #f0ad4e;
  color: #f0ad4e;
}

.back-to-home {
  position: fixed;
  top: 12px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-secondary);
  cursor: pointer;
  z-index: 500;
  transition: all 0.15s;
}

.back-to-home:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.back-to-home.sidebar-open {
  right: 236px;
  transition: right 0.2s;
}

.floating-add-buttons.sidebar-open {
  right: 276px;
  transition: right 0.2s;
}

/* ===== Side Menu ===== */
.side-menu {
  width: 300px;
  height: 100vh;
  background: var(--bg-sidebar);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  scrollbar-width: thin;
  scrollbar-color: var(--border-color) transparent;
}

.side-menu::-webkit-scrollbar {
  width: 4px;
}

.side-menu::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

.side-menu.collapsed {
  width: 48px;
  overflow: hidden;
  align-items: center;
  padding-top: 12px;
}

.menu-expand-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 18px;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.2s;
}

.menu-expand-btn:hover {
  color: var(--accent);
  background: var(--bg-primary);
  transform: scale(1.05);
}

/* Header */
.menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
  background: var(--bg-sidebar);
  position: sticky;
  top: 0;
  z-index: 2;
}

.menu-header h3 {
  font-size: 16px;
  font-weight: 800;
  color: var(--accent);
  letter-spacing: -0.3px;
}

.menu-brand-link {
  cursor: pointer;
  transition: opacity 0.15s;
}

.menu-brand-link:hover {
  opacity: 0.7;
}

.menu-header-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.menu-icon-btn {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  font-size: 16px;
  color: var(--text-primary);
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 8px;
  line-height: 1;
  transition: all 0.2s;
}

.menu-icon-btn:hover {
  color: var(--accent);
  border-color: var(--accent);
}

/* Sections */
.menu-section {
  padding: 12px 20px;
  border-bottom: 1px solid var(--border-color);
}

.menu-section:last-child {
  border-bottom: none;
}

/* Collapsible section header */
.menu-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 6px 8px;
  margin: -4px -8px;
  border-radius: 8px;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s;
}

.menu-section-header:hover {
  background: var(--bg-primary);
}

.menu-section-icon {
  font-size: 15px;
  line-height: 1;
}

.menu-section-title-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1 1;
  letter-spacing: 0.2px;
}

.menu-chevron {
  font-size: 9px;
  color: var(--text-secondary);
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-chevron.open {
  transform: rotate(90deg);
}

.menu-section-body {
  margin-top: 10px;
  padding: 14px;
  background: var(--bg-primary);
  border-radius: 15px;
  border: 1px solid var(--border-color);
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}

.menu-section-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-secondary);
  margin-bottom: 12px;
}

/* Add buttons */
.menu-row {
  display: flex;
  gap: 8px;
}

.menu-btn {
  flex: 1 1;
  padding: 10px;
  border: 1.5px dashed var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.menu-btn:hover:not(:disabled) {
  border-color: var(--accent);
  color: var(--accent);
  border-style: solid;
  background: var(--bg-secondary);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.menu-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.menu-hint {
  font-size: 11px;
  color: var(--danger);
  margin-top: 8px;
  font-style: italic;
  text-align: center;
}

.select-required {
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 2px rgba(74, 144, 217, 0.15);
}

/* Form fields */
.menu-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 14px;
}

.menu-field:last-child {
  margin-bottom: 0;
}

.menu-field label {
  font-size: 11px;
  color: var(--text-secondary);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.menu-field select,
.menu-field input {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  transition: all 0.2s;
}

.menu-field select {
  cursor: pointer;
}

.menu-field input:focus,
.menu-field select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);
}

.menu-field input::placeholder {
  color: var(--text-secondary);
  opacity: 0.6;
}

/* JWT auto-generate */
.input-with-btn {
  display: flex;
  gap: 6px;
}

.input-with-btn input {
  flex: 1 1;
  min-width: 0;
}

.auto-gen-btn {
  padding: 6px 12px;
  border: 1.5px solid var(--accent);
  border-radius: 8px;
  background: transparent;
  color: var(--accent);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  letter-spacing: 0.3px;
}

.auto-gen-btn:hover {
  background: var(--accent);
  color: #fff;
  transform: translateY(-1px);
}

.auto-gen-hint {
  font-size: 10px;
  color: var(--accent);
  font-style: italic;
  margin-top: 2px;
  padding-left: 2px;
}

/* Features grid */
.menu-features {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.menu-feature-item {
  width: calc(50% - 2px);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  cursor: pointer;
  color: var(--text-primary);
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: all 0.15s;
}

.menu-feature-item:hover {
  background: var(--bg-primary);
  border-color: var(--border-color);
}

.menu-feature-item.disabled {
  opacity: 0.5;
  cursor: default;
}

.menu-feature-item input[type="checkbox"] {
  accent-color: var(--accent);
  cursor: pointer;
  width: 15px;
  height: 15px;
}

.menu-feature-item span {
  text-transform: capitalize;
  font-weight: 500;
}

/* Action buttons */
.menu-actions {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
  position: sticky;
  bottom: 0;
  background: var(--bg-sidebar);
  border-top: 1px solid var(--border-color);
}

.menu-action-btn {
  padding: 10px 16px;
  border: 1.5px solid var(--border-color);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.menu-action-btn.preview {
  background: transparent;
  color: var(--accent);
  border-color: var(--accent);
}

.menu-action-btn.preview:hover {
  background: var(--accent);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(74, 144, 217, 0.2);
}

.menu-action-btn.generate {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

.menu-action-btn.generate:hover:not(:disabled) {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.3);
}

.menu-action-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* ===== Generation Result Modal ===== */
.gen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--popup-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.15s ease-out;
}

.gen-modal {
  background: var(--popup-bg);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  width: 400px;
  padding: 40px 36px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.3);
  animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modalPop {
  from { opacity: 0; transform: scale(0.85) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.gen-modal-icon {
  margin-bottom: 4px;
}

.success-icon svg {
  animation: checkDraw 0.5s ease-out 0.2s both;
}

@keyframes checkDraw {
  from { stroke-dasharray: 100; stroke-dashoffset: 100; }
  to { stroke-dasharray: 100; stroke-dashoffset: 0; }
}

.gen-modal-title {
  font-size: 22px;
  font-weight: 800;
  color: #2ea043;
  letter-spacing: -0.3px;
}

.gen-modal-title.error-title {
  color: var(--danger);
}

.gen-modal-desc {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
  margin-bottom: 4px;
}

.gen-download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #2ea043, #27893a);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 4px;
}

.gen-download-btn:hover {
  background: linear-gradient(135deg, #27893a, #1e6f2e);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(46, 160, 67, 0.35);
}

.gen-download-btn:active {
  transform: translateY(0);
}

.gen-expire {
  font-size: 11px;
  color: var(--text-secondary);
  font-style: italic;
}

.gen-close-btn {
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 10px 32px;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 4px;
}

.gen-close-btn:hover {
  border-color: var(--text-primary);
  color: var(--text-primary);
  background: var(--bg-primary);
}

/* ===== Auth Modal ===== */
.auth-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--popup-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.15s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.auth-modal {
  background: var(--popup-bg);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  width: 380px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.3);
  animation: slideDown 0.25s ease-out;
  overflow: hidden;
}

.auth-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
}

.auth-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.auth-close {
  background: none;
  border: none;
  font-size: 22px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  transition: color 0.15s;
}

.auth-close:hover {
  color: var(--text-primary);
}

.auth-tabs {
  display: flex;
  margin: 16px 24px 0;
  border-bottom: 2px solid var(--border-color);
}

.auth-tab {
  flex: 1 1;
  padding: 10px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.auth-tab:hover {
  color: var(--text-primary);
}

.auth-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.auth-form {
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.auth-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.auth-field label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-secondary);
}

.auth-field input {
  padding: 10px 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  transition: all 0.2s;
}

.auth-field input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);
}

.auth-error {
  padding: 8px 12px;
  background: rgba(248, 81, 73, 0.1);
  border: 1px solid rgba(248, 81, 73, 0.3);
  border-radius: 8px;
  color: var(--danger);
  font-size: 12px;
  font-weight: 500;
}

.auth-submit {
  padding: 11px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 4px;
}

.auth-submit:hover:not(:disabled) {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.3);
}

.auth-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-google-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.auth-google-btn:hover:not(:disabled) {
  background: var(--dropdown-hover);
  border-color: var(--accent);
  transform: translateY(-1px);
  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.15);
}

.auth-google-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-google-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.auth-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text-secondary);
}

.auth-divider::before,
.auth-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--border-color);
}

.menu-action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ===== Main Area ===== */
.main-area {
  flex: 1 1;
  display: flex;
  overflow: hidden;
}

.canvas-container {
  flex: 1 1;
  position: relative;
}

/* ===== Sidebar ===== */
.sidebar {
  width: 220px;
  background: var(--bg-sidebar);
  border-left: 1px solid var(--border-color);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-shrink: 0;
  overflow-y: auto;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-header h3 {
  font-size: 14px;
  font-weight: 600;
}

.sidebar-badge {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--accent);
  color: #fff;
  font-weight: 600;
}

.sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar-section-bottom {
  margin-top: auto;
}

.sidebar-info {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: var(--text-secondary);
}

.sidebar-count {
  font-weight: 600;
  color: var(--text-primary);
}

/* Field action rows (Above / Below / Delete) */
.field-action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.field-action-label {
  font-size: 13px;
  color: var(--text-primary);
}

.field-action-btn {
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 4px 6px;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.field-action-btn:hover:not(:disabled) {
  border-color: var(--accent);
  color: var(--accent);
}

.field-action-btn.delete:hover:not(:disabled) {
  border-color: var(--danger);
  color: var(--danger);
}

.field-action-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.field-count-input {
  width: 56px;
  padding: 4px 8px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
  text-align: center;
}

.sidebar-delete-table {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--danger);
  border-radius: 6px;
  background: transparent;
  color: var(--danger);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.sidebar-delete-table:hover {
  background: var(--danger);
  color: #fff;
}

/* ===== Entity Node ===== */
.entity-node {
  width: 234px;
  border: 2px solid var(--node-border);
  border-radius: 4px;
  background: var(--node-bg);
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: move;
}

.entity-node.selected {
  border-color: var(--node-selected-border);
  box-shadow: 0 0 0 2px var(--node-selected-border), 0 2px 8px rgba(0, 0, 0, 0.15);
}

.entity-header {
  padding: 6px 10px;
  background: var(--node-header);
  border-bottom: 1px solid var(--node-border);
  text-align: center;
  border-radius: 2px 2px 0 0;
}

.enum-header {
  background: var(--enum-header);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.enum-node {
  border-color: var(--enum-border);
  border-radius: 12px;
  width: 164px;
}

.enum-node .entity-header {
  border-radius: 10px 10px 0 0;
}

.enum-node .entity-fields .entity-field-row:last-child {
  border-radius: 0 0 10px 10px;
}

.enum-icon {
  font-size: 14px;
}

.entity-name-input {
  background: var(--input-bg);
  border: none;
  outline: none;
  font-size: 13px;
  font-weight: 700;
  color: var(--node-header-text);
  text-align: center;
  width: 100%;
  resize: none;
  overflow: hidden;
  line-height: 1.4;
  font-family: inherit;
  display: block;
}

.entity-name-input:focus {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}

/* ===== Entity Fields ===== */
.entity-fields {
  display: flex;
  flex-direction: column;
}

.entity-field-row {
  display: flex;
  align-items: center;
  padding: 3px 4px;
  border-bottom: 1px solid var(--border-color);
  position: relative;
  min-height: 28px;
  cursor: pointer;
  transition: background 0.1s;
}

.entity-field-row:last-child {
  border-bottom: none;
}

.entity-field-row.alt {
  background: var(--node-field-alt);
}

.entity-field-row.field-selected {
  background: var(--node-field-selected) !important;
}

.entity-field-row:hover {
  background: var(--node-field-selected);
}

.field-type-cell {
  flex: 1 1;
  min-width: 0;
  padding-right: 2px;
}

.field-type-cell.linked {
  cursor: not-allowed;
  opacity: 0.85;
}

.field-type-cell.linked .field-type-display {
  color: var(--accent);
}

.enum-field-name {
  flex: 1 1;
}

.field-name-cell {
  flex: 1 1;
  min-width: 0;
}

.field-name-input {
  background: var(--input-bg);
  border: none;
  outline: none;
  font-size: 12px;
  color: var(--text-primary);
  width: 100%;
  padding: 2px 4px;
  resize: none;
  overflow: hidden;
  line-height: 1.4;
  font-family: inherit;
  display: block;
}

.field-name-input:focus {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.field-name-input:disabled {
  color: var(--text-secondary);
  font-weight: 600;
}

/* ===== Display mode (read-only) ===== */
.entity-name-display {
  font-size: 13px;
  font-weight: 700;
  color: var(--node-header-text);
  text-align: center;
  padding: 2px 4px;
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
  word-break: break-word;
}

.field-type-display {
  font-size: 12px;
  color: var(--text-secondary);
  font-style: italic;
  padding: 2px 4px;
  -webkit-user-select: none;
          user-select: none;
  word-break: break-word;
}

.field-name-display {
  font-size: 12px;
  color: var(--text-primary);
  padding: 2px 4px;
  -webkit-user-select: none;
          user-select: none;
  word-break: break-word;
}

.field-name-display.id-field {
  color: var(--text-secondary);
  font-weight: 600;
}

.placeholder-text {
  color: var(--text-secondary);
  font-style: italic;
  font-weight: 400;
}

/* ===== Draggable field rows ===== */
.entity-field-row[draggable="true"] {
  cursor: grab;
}

.entity-field-row[draggable="true"]:active {
  cursor: grabbing;
  opacity: 0.6;
}

.entity-field-row.drag-over {
  border-top: 2px solid var(--accent);
}

.field-constraints {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}

.constraint-btn {
  width: 18px;
  height: 18px;
  border: 1px solid var(--border-color);
  border-radius: 3px;
  background: var(--constraint-bg);
  color: var(--text-secondary);
  font-size: 9px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.15s;
}

.constraint-btn.active {
  background: var(--constraint-active);
  color: #fff;
  border-color: var(--constraint-active);
}

/* ===== Field Handles ===== */
.field-handle {
  width: 8px !important;
  height: 8px !important;
  background: var(--node-border) !important;
  border: 2px solid var(--node-bg) !important;
  min-width: 8px !important;
  min-height: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.field-handle:hover {
  background: var(--accent) !important;
  width: 10px !important;
  height: 10px !important;
}

/* ===== Type Autocomplete ===== */
.type-autocomplete {
  position: relative;
}

.type-input {
  width: 100%;
  padding: 2px 4px;
  border: none;
  outline: none;
  font-size: 12px;
  background: var(--input-bg);
  color: var(--text-secondary);
  font-style: italic;
  resize: none;
  overflow: hidden;
  line-height: 1.4;
  font-family: inherit;
  display: block;
}

.type-input:focus {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  color: var(--text-primary);
  font-style: normal;
}

.type-dropdown {
  position: absolute;
  top: 100%;
  left: -4px;
  width: 150px;
  max-height: 200px;
  overflow-y: auto;
  background: var(--dropdown-bg);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.type-option {
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.1s;
}

.type-option:hover {
  background: var(--dropdown-hover);
}

.type-option.active {
  background: var(--dropdown-hover);
  font-weight: 600;
}

/* ===== Connection Popup ===== */
.connection-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--popup-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.connection-popup {
  background: var(--popup-bg);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 24px;
  min-width: 280px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.connection-popup h4 {
  font-size: 16px;
  margin-bottom: 8px;
}

.popup-desc {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

.popup-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 16px;
}

.popup-rel-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.15s;
}

.popup-rel-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.popup-rel-icon {
  color: var(--text-secondary);
}

.popup-rel-btn:hover .popup-rel-icon {
  color: var(--accent);
}

.popup-rel-label {
  font-size: 13px;
  font-weight: 600;
}

.popup-cancel {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}

/* ===== React Flow Overrides ===== */
.react-flow__background {
  background: var(--bg-primary) !important;
}

.react-flow__controls {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.react-flow__controls-button {
  background: var(--bg-secondary) !important;
  border-color: var(--border-color) !important;
  color: var(--text-primary) !important;
  fill: var(--text-primary) !important;
}

.react-flow__minimap {
  border: 1px solid var(--border-color);
  border-radius: 4px;
}

/* ===== Pricing Section ===== */
.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  max-width: 1180px;
  margin: 0 auto;
  align-items: start;
}

.pricing-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 18px;
  padding: 44px 36px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  position: relative;
  transition: all 0.2s;
}

.pricing-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.pricing-card.popular {
  border-color: var(--accent);
  border-width: 2px;
  box-shadow: 0 4px 24px rgba(74, 144, 217, 0.15);
}

.pricing-popular-badge {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 20px;
  background: linear-gradient(135deg, var(--accent), #7c3aed);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  border-radius: 20px;
  letter-spacing: 0.3px;
}

.pricing-card-header {
  text-align: center;
}

.pricing-plan-name {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 14px;
}

.pricing-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  margin-bottom: 10px;
}

.pricing-amount {
  font-size: 48px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -1.5px;
}

.pricing-old {
  font-size: 22px;
  font-weight: 600;
  color: var(--text-secondary);
  text-decoration: line-through;
}

.pricing-period {
  font-size: 15px;
  color: var(--text-secondary);
  font-weight: 500;
}

.pricing-plan-desc {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.pricing-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1;
}

.pricing-features li {
  font-size: 15px;
  color: var(--text-primary);
  padding-left: 28px;
  position: relative;
  line-height: 1.5;
}

.pricing-features li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  width: 18px;
  height: 18px;
  background: rgba(46, 160, 67, 0.15);
  border-radius: 50%;
}

.pricing-features li::after {
  content: '✓';
  position: absolute;
  left: 4px;
  top: 2px;
  font-size: 12px;
  color: #2ea043;
  font-weight: 700;
}

.pricing-features li.pricing-feature-includes {
  font-size: 16px;
  font-weight: 700;
  color: var(--accent);
  padding-bottom: 14px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--border-color);
  letter-spacing: 0.2px;
}

.pricing-features li.pricing-feature-includes::before {
  background: var(--accent);
  opacity: 0.15;
}

.pricing-features li.pricing-feature-includes::after {
  content: '+';
  color: var(--accent);
  font-size: 17px;
  top: 0;
  left: 3px;
}

.pricing-beta-overlay {
  text-align: center;
}

.pricing-beta-tag {
  display: inline-block;
  padding: 6px 16px;
  background: linear-gradient(135deg, rgba(74, 144, 217, 0.1), rgba(130, 80, 223, 0.1));
  border: 1px solid rgba(74, 144, 217, 0.2);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: var(--accent);
  letter-spacing: 0.3px;
}

.pricing-btn {
  width: 100%;
  padding: 16px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: transparent;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.pricing-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.pricing-btn.current {
  background: rgba(74, 144, 217, 0.1);
  border-color: var(--accent);
  color: var(--accent);
}

.pricing-btn.pro {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.pricing-btn.pro:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(74, 144, 217, 0.3);
}

.pricing-card.blurred .pricing-card-header,
.pricing-card.blurred .pricing-features {
  filter: blur(3px);
  opacity: 0.5;
  -webkit-user-select: none;
          user-select: none;
}

.pricing-card.blurred {
  position: relative;
}

.pricing-card.blurred:hover {
  transform: none;
  box-shadow: none;
}

.pricing-coming-soon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 8px 24px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.5px;
  z-index: 2;
}

.pricing-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.comparison-block {
  margin-top: 80px;
  max-width: 1180px;
  margin-left: auto;
  margin-right: auto;
}

.comparison-header {
  text-align: center;
  margin-bottom: 36px;
}

.comparison-header h3 {
  font-size: 26px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 10px;
}

.comparison-header p {
  font-size: 15px;
  color: var(--text-secondary);
}

.comparison-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.comparison-card {
  border-radius: 18px;
  padding: 32px 28px;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.comparison-card.backora {
  border-color: rgba(46, 160, 67, 0.4);
  box-shadow: 0 4px 16px rgba(46, 160, 67, 0.08);
}

.comparison-card.diy {
  opacity: 0.92;
}

.comparison-card-header {
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
}

.comparison-card-header h4 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 6px 0;
  color: var(--text-primary);
}

.comparison-card-header p {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
}

.comparison-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.comparison-list li {
  font-size: 14px;
  color: var(--text-primary);
  padding-left: 28px;
  position: relative;
  line-height: 1.5;
}

.comparison-card.backora .comparison-list li::before {
  content: '✓';
  position: absolute;
  left: 4px;
  top: 0;
  color: #2ea043;
  font-weight: 700;
  font-size: 16px;
}

.comparison-card.diy .comparison-list li::before {
  content: '⏱';
  position: absolute;
  left: 2px;
  top: 0;
  font-size: 14px;
}

.comparison-cta {
  text-align: center;
  margin-top: 32px;
  font-size: 16px;
  color: var(--text-primary);
  font-weight: 600;
}

@media (max-width: 768px) {
  .comparison-grid {
    grid-template-columns: 1fr;
  }
  .comparison-block {
    margin-top: 56px;
  }
}

.pricing-note {
  text-align: center;
  margin-top: 24px;
  font-size: 13px;
  color: var(--text-secondary);
  font-style: italic;
}

@media (max-width: 768px) {
  .pricing-grid {
    grid-template-columns: 1fr;
    max-width: 400px;
  }
}

.edge-code-tooltip {
  background: var(--node-bg, var(--bg-secondary));
  border: 1.2px solid var(--accent);
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.35);
  z-index: 9999;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre;
}

.edge-code-line {
  color: var(--text-primary);
}

.edge-code-kw {
  color: var(--accent);
  font-weight: 600;
}

.edge-code-annotation {
  color: var(--accent);
  font-weight: 600;
}

.edge-code-type {
  color: #e5c07b;
}

.edge-code-dots {
  color: var(--text-secondary);
}

.edge-code-class {
  font-weight: 600;
}

.edge-code-key {
  color: #9cdcfe;
}

.edge-code-comment {
  color: #6a9955;
  font-style: italic;
}

.edge-code-indent {
  padding-left: 14px;
}

/* Hover mode toggle (Code | JSON) — placed in floating-add-buttons */
.floating-divider {
  width: 1px;
  height: 22px;
  background: var(--border-color);
  margin: 0 4px;
}

.hover-mode-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.hover-mode-label {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 500;
}

.hover-mode-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.hover-mode-btn:hover {
  border-color: var(--accent);
  color: var(--text-primary);
}

.hover-mode-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

/* ========================================
   RESPONSIVE - Mobile & Tablet
   ======================================== */

@media (max-width: 768px) {
  /* Landing nav */
  .landing-nav-links { display: none; }
  .mobile-menu-btn { display: flex; }
  .mobile-nav-dropdown { display: flex; }

  .landing-nav {
    padding: 12px 16px;
  }

  .landing-nav-actions {
    gap: 6px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .landing-btn-ghost,
  .landing-btn-primary {
    padding: 6px 14px;
    font-size: 12px;
  }

  .landing-hero {
    padding: 40px 20px 60px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-desc {
    font-size: 14px;
  }

  .hero-actions {
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }

  .hero-btn-primary,
  .hero-btn-outline {
    width: 100%;
    justify-content: center;
    padding: 12px;
  }

  .landing-features {
    flex-direction: column;
    padding: 30px 20px 50px;
    gap: 16px;
  }

  .landing-section { padding: 48px 20px; }
  .section-title { font-size: 24px; }
  .how-steps { flex-direction: column; align-items: center; }
  .how-step-arrow { transform: rotate(90deg); padding: 0; }
  .features-grid { grid-template-columns: 1fr; }
  .who-grid { grid-template-columns: 1fr 1fr; }
  .contact-cards { flex-direction: column; align-items: center; }
  .contact-card { min-width: auto; width: 100%; }
  .landing-cta { padding: 48px 20px; }
  .landing-cta h2 { font-size: 24px; }
  .footer-content { flex-direction: column; gap: 24px; padding: 32px 20px; }
  .footer-bottom { padding: 16px 20px; }

  /* Home / Dashboard */
  .home-nav {
    padding: 12px 16px;
  }

  .home-content {
    padding: 20px 16px;
  }

  .home-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .home-title {
    font-size: 20px;
  }

  .home-new-btn {
    align-self: flex-start;
  }

  .home-grid {
    grid-template-columns: 1fr;
  }

  /* Profile */
  .profile-content {
    padding: 20px 16px;
  }

  .profile-title {
    font-size: 20px;
  }

  .verify-code-row {
    flex-direction: column;
  }

  /* Editor */
  .main-layout {
    flex-direction: column;
    height: 100vh;
  }

  /* Side menu - overlay on mobile */
  .side-menu {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 400;
    height: 100vh;
    width: 280px;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.2);
  }

  .side-menu.collapsed {
    left: -48px;
    width: 48px;
    box-shadow: none;
  }

  /* Right sidebar - overlay on mobile */
  .sidebar {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 350;
    height: 100vh;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.2);
  }

  .main-area {
    flex: 1 1;
    width: 100vw;
  }

  .canvas-container {
    width: 100%;
    height: 100%;
  }

  /* Floating buttons */
  .floating-add-buttons {
    top: auto;
    bottom: 16px;
    right: 16px;
    flex-direction: column;
  }

  .floating-add-buttons.sidebar-open {
    right: 16px;
  }

  .back-to-home {
    top: 12px;
    right: 12px;
  }

  .back-to-home.sidebar-open {
    right: 12px;
  }

  .save-indicator {
    bottom: 80px;
    right: 12px;
  }

  /* Auth modal */
  .auth-modal {
    width: calc(100vw - 32px);
    max-width: 380px;
  }

  /* Popups */
  .connection-popup {
    min-width: auto;
    width: calc(100vw - 32px);
    max-width: 360px;
  }

  .popup-buttons {
    flex-direction: column;
  }

  .gen-modal {
    width: calc(100vw - 32px);
    max-width: 400px;
    padding: 28px 20px 24px;
  }

  .confirm-modal {
    width: calc(100vw - 32px);
    max-width: 360px;
  }

  /* Profile menu */
  .profile-menu {
    right: -8px;
    width: 180px;
  }

  /* Lang switcher compact */
  .lang-btn {
    padding: 3px 8px;
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 24px;
  }

  .landing-logo {
    font-size: 15px;
  }

  .side-menu {
    width: 260px;
  }

  .home-title {
    font-size: 18px;
  }

  .entity-node {
    width: 180px;
  }

  .enum-node {
    width: 130px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,+BAA+B;EAC/B,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,6BAA6B;AAC7B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,yDAAyD;AAC3D;;AAEA,kBAAkB,6BAA6B,EAAE,0BAA0B,EAAE;AAC7E,iBAAiB,6BAA6B,EAAE,0BAA0B,EAAE;;AAE5E;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb;;kFAEgF;EAChF,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB;;uBAEqB;EACrB,qCAAqC;EACrC;;;uCAGqC;EACrC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,oDAAoD;AACtD;;AAEA;EACE,WAAW,4CAA4C,EAAE;EACzD,WAAW,0CAA0C,EAAE;AACzD;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C,gCAAgC,oCAAoC,GAAG,cAAc,EAAE;AACvF,gCAAgC,mCAAmC,IAAI,cAAc,EAAE;AACvF,gCAAgC,oCAAoC,GAAG,cAAc,EAAE;AACvF,gCAAgC,oCAAoC,GAAG,cAAc,EAAE;AACvF,gCAAgC,oCAAoC,GAAG,cAAc,EAAE;AACvF,gCAAgC,oCAAoC,GAAG,cAAc,EAAE;AACvF,gCAAgC,mCAAmC,IAAI,cAAc,EAAE;AACvF,gCAAgC,oCAAoC,GAAG,cAAc,EAAE;;AAEvF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;;;;IAIE,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;EACpB;EACA,iBAAiB,gBAAgB,EAAE,WAAW,EAAE;AAClD;;AAEA;EACE,sBAAsB,kBAAkB,EAAE;EAC1C,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,WAAW,EAAE,YAAY,EAAE;AAC/C;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qDAAqD;EACrD,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC;;;2CAGyC;EACzC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qEAAqE;EACrE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,iBAAiB,mBAAmB,EAAE;AACtC,iBAAiB,mBAAmB,EAAE;AACtC,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,mFAAmF;EACnF,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,yCAAyC;EACzC,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,4CAA4C;EAC5C,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW,0CAA0C,EAAE;EACvD,WAAW,0CAA0C,EAAE;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;EAC5C,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,oBAAoB,oCAAoC,GAAG,cAAc,EAAE;AAC3E,oBAAoB,mCAAmC,IAAI,cAAc,EAAE;AAC3E,oBAAoB,oCAAoC,GAAG,cAAc,EAAE;AAC3E,oBAAoB,mCAAmC,IAAI,cAAc,EAAE;;AAE3E;EACE,0BAA0B;EAC1B,SAAO;AACT;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,iBAAiB,eAAe,EAAE;EAClC;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,uBAAuB;EACzB;EACA,YAAY,YAAY,EAAE;EAC1B,cAAc,eAAe,EAAE;AACjC;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,2DAA2D;EAC3D,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,EAAE,4CAA4C,EAAE;EACrE,WAAW,YAAY,EAAE,4CAA4C,EAAE;AACzE;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,8EAA8E;EAC9E;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;;IAEE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;EACf;;EAEA,wCAAwC;EACxC;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,4DAA4D;AAC5D;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,2DAA2D;EAC3D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,oBAAoB;EACpB,uDAAuD;EACvD,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC,kCAAkC;AAClC;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB;0DACwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2DAA2D;EAC3D,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,MAAM;AACR;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;;;;;EAKE,oBAAoB;EACpB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;EACjB,oCAAoC;EACpC,+BAA+B;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,wCAAwC;EACxC,yCAAyC;EACzC,sBAAsB;EACtB,2CAA2C;;EAE3C,4EAA4E;EAC5E,qBAAqB;EACrB,sCAAsC;EACtC,wCAAwC;EACxC,uBAAuB;EACvB,0CAA0C;EAC1C,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;EAC1C,uCAAuC;EACvC,0CAA0C;EAC1C,kCAAkC;;EAElC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uFAAuF;EACvF,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8EAA8E;EAC9E,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kFAAkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yFAAyF;EACzF,2CAA2C;EAC3C,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB;;;2CAGyC;EACzC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,0EAA0E;AAC1E;EACE,UAAU;EACV,OAAO;AACT;;AAEA;EACE,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C;;uCAEqC;EACrC,aAAa;AACf;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,8BAA8B;EAC9B;;eAEa;EACb,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yFAAyF;EACzF,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,0CAA0C;EAC1C,oBAAoB;EACpB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,+DAA+D;EAC/D,eAAe;EACf,gBAAgB;EAChB,yFAAyF;EACzF,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,+EAA+E;EAC/E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0EAA0E;EAC1E,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6EAA6E;AAC7E;EACE,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,iFAAiF;EACjF,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,KAAK,UAAU,EAAE,6BAA6B,EAAE;AAClD;;AAEA;EACE,OAAO,UAAU,EAAE,6BAA6B,EAAE;EAClD,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,8EAA8E;AAChF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,+EAA+E;EAC/E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA,4CAA4C,sBAAsB,EAAE,UAAU,EAAE;AAChF,4CAA4C,kBAAkB,EAAE,UAAU,EAAE;AAC5E,4CAA4C,oBAAoB,EAAE,UAAU,EAAE;;AAE9E;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,+DAA+D;EAC/D,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,+DAA+D;EAC/D,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;EAClE,mBAAmB,sBAAsB,EAAE,SAAS,EAAE;EACtD,cAAc,WAAW,EAAE,wBAAwB,EAAE;EACrD,aAAa,eAAe,EAAE,WAAW,EAAE;EAC3C,4BAA4B,gBAAgB,EAAE;AAChD;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,+FAA+F;EAC/F,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6FAA6F;EAC7F,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,2DAA2D;EAC3D,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,OAAO,qBAAqB,EAAE,sBAAsB,EAAE;EACtD,KAAK,qBAAqB,EAAE,oBAAoB,EAAE;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,sCAAsC;AACxC;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,2DAA2D;EAC3D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,qFAAqF;EACrF,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;6CAE6C;;AAE7C;EACE,gBAAgB;EAChB,qBAAqB,aAAa,EAAE;EACpC,mBAAmB,aAAa,EAAE;EAClC,uBAAuB,aAAa,EAAE;;EAEtC;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,yBAAyB;EAC3B;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA,mBAAmB,kBAAkB,EAAE;EACvC,iBAAiB,eAAe,EAAE;EAClC,aAAa,sBAAsB,EAAE,mBAAmB,EAAE;EAC1D,kBAAkB,wBAAwB,EAAE,UAAU,EAAE;EACxD,iBAAiB,0BAA0B,EAAE;EAC7C,YAAY,8BAA8B,EAAE;EAC5C,iBAAiB,sBAAsB,EAAE,mBAAmB,EAAE;EAC9D,gBAAgB,eAAe,EAAE,WAAW,EAAE;EAC9C,eAAe,kBAAkB,EAAE;EACnC,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,sBAAsB,EAAE,SAAS,EAAE,kBAAkB,EAAE;EACzE,iBAAiB,kBAAkB,EAAE;;EAErC,qBAAqB;EACrB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,YAAY;EACZ;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,WAAW;EACX;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,0CAA0C;EAC5C;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,SAAS;IACT,YAAY;IACZ,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA,eAAe;EACf;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* ===== CSS Variables ===== */\n.app-root.light,\n.app.light {\n  --bg-primary: #f5f5f5;\n  --bg-secondary: #ffffff;\n  --bg-toolbar: #ffffff;\n  --bg-sidebar: #ffffff;\n  --text-primary: #1a1a1a;\n  --text-secondary: #555;\n  --border-color: #ddd;\n  --accent: #4a90d9;\n  --accent-hover: #357abd;\n  --danger: #d9534f;\n  --danger-hover: #c9302c;\n  --node-bg: #ffffff;\n  --node-header: #d4dce4;\n  --node-header-text: #1a1a1a;\n  --node-field-alt: #e8ecf0;\n  --node-field-selected: #cce0ff;\n  --node-border: #999;\n  --node-selected-border: #4a90d9;\n  --enum-header: #f0e6d0;\n  --enum-border: #b8a070;\n  --edge-color: #555;\n  --input-bg: transparent;\n  --constraint-bg: #e0e0e0;\n  --constraint-active: #4a90d9;\n  --dropdown-bg: #fff;\n  --dropdown-hover: #e8f0fe;\n  --popup-bg: #fff;\n  --popup-overlay: rgba(0, 0, 0, 0.3);\n}\n\n.app-root.dark,\n.app.dark {\n  --bg-primary: #0d1117;\n  --bg-secondary: #161b22;\n  --bg-toolbar: #161b22;\n  --bg-sidebar: #161b22;\n  --text-primary: #e6edf3;\n  --text-secondary: #8b949e;\n  --border-color: #30363d;\n  --accent: #58a6ff;\n  --accent-hover: #79b8ff;\n  --danger: #f85149;\n  --danger-hover: #da3633;\n  --node-bg: #1c2128;\n  --node-header: #2d333b;\n  --node-header-text: #e6edf3;\n  --node-field-alt: #22272e;\n  --node-field-selected: #1f3a5f;\n  --node-border: #444c56;\n  --node-selected-border: #58a6ff;\n  --enum-header: #3d3328;\n  --enum-border: #6e5c3a;\n  --edge-color: #8b949e;\n  --input-bg: transparent;\n  --constraint-bg: #30363d;\n  --constraint-active: #58a6ff;\n  --dropdown-bg: #1c2128;\n  --dropdown-hover: #1f3a5f;\n  --popup-bg: #1c2128;\n  --popup-overlay: rgba(0, 0, 0, 0.6);\n}\n\n/* ===== Reset & Base ===== */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  -webkit-text-size-adjust: 100%;\n  overflow-x: hidden;\n}\n\n/* Scrollbar - Dark theme (default) */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0d1117;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #444c56;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #58a6ff;\n}\n\n/* Scrollbar - Light theme */\nhtml[data-theme=\"light\"] ::-webkit-scrollbar-track,\nhtml[data-theme=\"light\"]::-webkit-scrollbar-track {\n  background: #f0f0f0;\n}\n\nhtml[data-theme=\"light\"] ::-webkit-scrollbar-thumb,\nhtml[data-theme=\"light\"]::-webkit-scrollbar-thumb {\n  background: #bbb;\n  border-radius: 10px;\n}\n\nhtml[data-theme=\"light\"] ::-webkit-scrollbar-thumb:hover,\nhtml[data-theme=\"light\"]::-webkit-scrollbar-thumb:hover {\n  background: #4a90d9;\n}\n\n.app-root {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n/* Page transition */\n@keyframes pageSlideIn {\n  from { opacity: 0; transform: translateX(12px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes pageFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.landing {\n  animation: pageFadeIn 0.35s ease-out;\n}\n\n.home-page,\n.app,\n.profile-content {\n  animation: pageSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.app-root.light { background: var(--bg-primary); color: var(--text-primary); }\n.app-root.dark { background: var(--bg-primary); color: var(--text-primary); }\n\n.app {\n  width: 100vw;\n  height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  overflow: hidden;\n}\n\n.main-layout {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n}\n\n/* ===== Landing Page ===== */\n.landing {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.landing-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 40px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  backdrop-filter: blur(12px);\n}\n\n.app-root.light .landing-nav {\n  background: rgba(255, 255, 255, 0.85);\n}\n\n.app-root.dark .landing-nav {\n  background: rgba(22, 27, 34, 0.85);\n}\n\n.landing-logo {\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--accent);\n  letter-spacing: -0.5px;\n}\n\n.landing-nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Language Switcher */\n.lang-switcher {\n  display: flex;\n  gap: 2px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 2px;\n}\n\n.lang-btn {\n  padding: 4px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.lang-btn:hover {\n  color: var(--text-primary);\n}\n\n.lang-btn.active {\n  background: var(--accent);\n  color: #fff;\n}\n\n.landing-btn-ghost {\n  padding: 8px 20px;\n  background: none;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.landing-btn-ghost:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.landing-btn-primary {\n  padding: 8px 20px;\n  background: var(--accent);\n  border: 1px solid var(--accent);\n  border-radius: 8px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.landing-btn-primary:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n/* Hero */\n.landing-hero {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 80px 40px;\n  gap: 20px;\n}\n\n/* Split hero: text + feature card */\n.landing-hero.hero-split {\n  position: relative;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 56px;\n  padding: 100px 40px 90px;\n  text-align: left;\n  overflow: hidden;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.hero-bg-glow {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 900px;\n  height: 600px;\n  background:\n    radial-gradient(ellipse at 30% 30%, rgba(74, 144, 217, 0.18), transparent 60%),\n    radial-gradient(ellipse at 70% 60%, rgba(124, 58, 237, 0.10), transparent 70%);\n  filter: blur(40px);\n  z-index: 0;\n  pointer-events: none;\n}\n\n.hero-text {\n  position: relative;\n  z-index: 1;\n  flex: 1 1 480px;\n  max-width: 560px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.hero-text .hero-badge {\n  align-self: flex-start;\n}\n\n.hero-split .hero-title {\n  font-size: clamp(36px, 4.5vw, 56px);\n  line-height: 1.05;\n  letter-spacing: -0.02em;\n  margin: 0;\n  text-align: left;\n}\n\n.hero-split .hero-desc {\n  font-size: clamp(15px, 1.2vw, 17px);\n  line-height: 1.6;\n  color: var(--text-secondary);\n  text-align: left;\n  margin: 0;\n}\n\n.hero-split .hero-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  margin-top: 6px;\n}\n\n/* ===== Hero feature card (right side) ===== */\n.hero-features {\n  position: relative;\n  z-index: 1;\n  flex: 1 1 420px;\n  max-width: 480px;\n}\n\n.hero-features-card {\n  position: relative;\n  border-radius: 18px;\n  padding: 24px 26px;\n  background:\n    linear-gradient(180deg, rgba(74, 144, 217, 0.06), transparent 60%),\n    var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.05) inset,\n    0 24px 60px -20px rgba(74, 144, 217, 0.25),\n    0 8px 30px -8px rgba(0, 0, 0, 0.15);\n  backdrop-filter: blur(8px);\n  overflow: hidden;\n}\n\n.hero-features-card::before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(74, 144, 217, 0.5), transparent);\n}\n\n.hero-features-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 12px;\n  background: rgba(46, 160, 67, 0.12);\n  color: #2ea043;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  border-radius: 20px;\n  margin-bottom: 18px;\n}\n\n.hero-features-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #2ea043;\n  box-shadow: 0 0 0 3px rgba(46, 160, 67, 0.2);\n  animation: hero-feat-pulse 2.4s ease-in-out infinite;\n}\n\n@keyframes hero-feat-pulse {\n  0%, 100% { box-shadow: 0 0 0 3px rgba(46, 160, 67, 0.2); }\n  50%      { box-shadow: 0 0 0 5px rgba(46, 160, 67, 0); }\n}\n\n.hero-features-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.hero-feat-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 10px;\n  border-radius: 9px;\n  transition: all 0.2s ease;\n  cursor: default;\n}\n\n.hero-feat-item:hover {\n  background: rgba(74, 144, 217, 0.06);\n  transform: translateX(2px);\n}\n\n.hero-feat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  background: rgba(74, 144, 217, 0.12);\n  color: var(--accent);\n  transition: all 0.2s ease;\n}\n\n.hero-feat-item:hover .hero-feat-icon {\n  background: rgba(74, 144, 217, 0.2);\n  transform: scale(1.05);\n}\n\n/* Per-icon color tints — gentle palette */\n.hero-feat-icon.icon-rocket   { background: rgba(74, 144, 217, 0.12);  color: #4a90d9; }\n.hero-feat-icon.icon-lock     { background: rgba(46, 160, 67, 0.12);   color: #2ea043; }\n.hero-feat-icon.icon-globe    { background: rgba(124, 58, 237, 0.14);  color: #7c3aed; }\n.hero-feat-icon.icon-database { background: rgba(240, 173, 78, 0.14);  color: #f0ad4e; }\n.hero-feat-icon.icon-backup   { background: rgba(228, 77, 144, 0.12);  color: #e44d90; }\n.hero-feat-icon.icon-pulse    { background: rgba(99, 102, 241, 0.14);  color: #6366f1; }\n.hero-feat-icon.icon-sync     { background: rgba(46, 160, 67, 0.12);   color: #2ea043; }\n.hero-feat-icon.icon-mail     { background: rgba(74, 144, 217, 0.12);  color: #4a90d9; }\n\n.hero-feat-text {\n  font-size: 13.5px;\n  line-height: 1.4;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n@media (max-width: 980px) {\n  .landing-hero.hero-split {\n    flex-direction: column;\n    gap: 36px;\n    padding: 64px 24px 56px;\n  }\n  .hero-text {\n    align-items: center;\n    text-align: center;\n    max-width: 600px;\n  }\n  .hero-text .hero-badge,\n  .hero-split .hero-title,\n  .hero-split .hero-desc,\n  .hero-split .hero-actions {\n    text-align: center;\n    justify-content: center;\n    align-self: center;\n  }\n  .hero-features { max-width: 540px; width: 100%; }\n}\n\n@media (max-width: 540px) {\n  .hero-features-card { padding: 20px 18px; }\n  .hero-feat-text { font-size: 13px; }\n  .hero-feat-icon { width: 28px; height: 28px; }\n}\n\n/* Two-column hero: text left, stacked showcase right */\n.landing-hero.hero-two-col {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 40px;\n  padding: 40px 28px 40px max(48px, calc(50vw - 600px));\n  max-width: none;\n  margin: 0;\n  text-align: left;\n}\n\n.hero-text-col {\n  flex: 1 1 500px;\n  max-width: 640px;\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  padding: 40px 0;\n}\n\n.hero-text-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.hero-two-col .hero-badge {\n  align-self: flex-start;\n}\n\n.hero-two-col .hero-title {\n  text-align: left;\n  margin: 0;\n}\n\n.hero-two-col .hero-desc {\n  text-align: left;\n}\n\n.hero-two-col .hero-actions {\n  justify-content: flex-start;\n  margin: 8px 0 0 !important;\n}\n\n.hero-two-col .hero-langs {\n  justify-content: flex-start;\n}\n\n.hero-visual-col {\n  flex: 1 1 560px;\n  max-width: 640px;\n  width: 100%;\n  align-self: stretch;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n}\n\n/* Stacked showcase: schema top-left, project bottom-right, connected by kite line */\n.vision-showcase.stacked {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1.3;\n  min-height: 380px;\n  max-height: 540px;\n}\n\n.stacked-schema,\n.stacked-project {\n  position: absolute;\n  width: 38%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  z-index: 2;\n}\n\n.stacked-schema {\n  top: 40px;\n  left: 14%;\n}\n\n.stacked-project {\n  bottom: 40px;\n  right: 0;\n}\n\n.vision-showcase.stacked .show-card {\n  padding: 10px;\n  border-radius: 12px;\n}\n\n.vision-showcase.stacked .pic-table-head {\n  padding: 4px 7px;\n  font-size: 9.5px;\n}\n\n.vision-showcase.stacked .pic-row {\n  padding: 3px 7px;\n  font-size: 9px;\n}\n\n.vision-showcase.stacked .pic-field-type {\n  font-size: 8px;\n}\n\n.vision-showcase.stacked .diagram-tables {\n  gap: 8px;\n}\n\n.vision-showcase.stacked .tree-card {\n  font-size: 9.5px;\n  padding: 10px 8px;\n}\n\n.vision-showcase.stacked .tree-row {\n  padding: 2px 5px;\n  font-size: 9.5px;\n}\n\n.vision-showcase.stacked .tree-label {\n  font-size: 9.5px;\n}\n\n.vision-showcase.stacked .show-card.diagram-card,\n.vision-showcase.stacked .show-card.tree-card,\n.vision-showcase.stacked .show-card.api-card {\n  min-height: 0;\n  max-height: none;\n}\n\n.vision-showcase.stacked .tree-card {\n  font-size: 11px;\n  padding: 10px 8px;\n}\n\n.vision-showcase.stacked .tree-row {\n  padding: 2px 6px;\n}\n\n.vision-showcase.stacked .tree-label {\n  font-size: 11px;\n}\n\n/* ===== Hero Showcase — Live demo (schema → API on one screen) ===== */\n.hero-showcase {\n  width: 100%;\n  max-width: 620px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 18px;\n}\n\n.hs-window {\n  width: 100%;\n  border-radius: 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 20px 60px -10px rgba(0, 0, 0, 0.25),\n    0 8px 20px -4px rgba(74, 144, 217, 0.1);\n  overflow: hidden;\n  animation: hs-float 6s ease-in-out infinite;\n}\n\n@keyframes hs-float {\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-4px); }\n}\n\n.hs-window-bar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 11px 14px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.05), transparent);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.hs-dots {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.hs-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.hs-dot.red    { background: #ff5f57; }\n.hs-dot.yellow { background: #febc2e; }\n.hs-dot.green  { background: #28c840; }\n\n.hs-bar-title {\n  flex: 1;\n  text-align: center;\n  font-size: 11.5px;\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-family: 'Consolas', 'Monaco', monospace;\n}\n\n.hs-bar-spacer {\n  width: 56px;\n  flex-shrink: 0;\n}\n\n/* ===== Split body: canvas + API side by side ===== */\n.hs-split {\n  display: flex;\n  height: 360px;\n  background: var(--bg-primary);\n}\n\n.hs-canvas,\n.hs-api {\n  position: relative;\n  height: 100%;\n  padding: 14px 16px;\n  overflow: hidden;\n}\n\n.hs-canvas {\n  flex: 1.2;\n  border-right: 1px solid var(--border-color);\n}\n\n.hs-api {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.hs-side-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  margin-bottom: 10px;\n  position: relative;\n  z-index: 5;\n}\n\n.hs-side-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--accent);\n}\n\n.hs-side-dot.live {\n  background: #2ea043;\n  animation: hs-pulse 2s ease-in-out infinite;\n}\n\n/* ===== Canvas grid background ===== */\n.hs-canvas-grid {\n  position: absolute;\n  inset: 0;\n  background-image: radial-gradient(circle, var(--border-color) 1px, transparent 1px);\n  background-size: 16px 16px;\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n/* ===== Tables ===== */\n.hs-tables {\n  position: relative;\n  z-index: 2;\n  height: calc(100% - 28px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 6px 28px 6px 4px;\n}\n\n.hs-table {\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--accent);\n  border-radius: 8px;\n  width: 150px;\n  font-size: 10.5px;\n  box-shadow: 0 4px 14px rgba(74, 144, 217, 0.15);\n}\n\n.hs-table-head {\n  background: rgba(74, 144, 217, 0.2);\n  color: var(--accent);\n  font-weight: 700;\n  padding: 5px 10px;\n  border-radius: 7px 7px 0 0;\n  font-size: 11px;\n  letter-spacing: 0.3px;\n}\n\n.hs-table-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 3px 10px;\n  border-top: 1px solid var(--border-color);\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 10px;\n}\n\n.hs-table-row.fk {\n  color: #f0ad4e;\n}\n\n.hs-field-name {\n  color: var(--text-primary);\n}\n\n.hs-field-type {\n  color: var(--text-secondary);\n}\n\n/* ===== Relation line (static) ===== */\n.hs-relation {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  pointer-events: none;\n}\n\n/* ===== Right side: Live API output ===== */\n.hs-url-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 11px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.hs-globe {\n  color: var(--text-secondary);\n  display: inline-flex;\n}\n\n.hs-url {\n  flex: 1;\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 11px;\n  color: var(--text-primary);\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hs-live {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.6px;\n  color: #2ea043;\n  padding: 2px 7px;\n  background: rgba(46, 160, 67, 0.12);\n  border-radius: 9px;\n}\n\n.hs-live-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #2ea043;\n  animation: hs-pulse 2s ease-in-out infinite;\n}\n\n@keyframes hs-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(46, 160, 67, 0.5); }\n  50%      { box-shadow: 0 0 0 5px rgba(46, 160, 67, 0); }\n}\n\n.hs-endpoints {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: relative;\n  z-index: 2;\n}\n\n.hs-endpoint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  background: var(--bg-secondary);\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 11px;\n  transition: transform 0.15s, background 0.15s;\n}\n\n.hs-endpoint:hover {\n  background: var(--bg-primary);\n  transform: translateX(2px);\n}\n\n.hs-method {\n  display: inline-block;\n  min-width: 40px;\n  text-align: center;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n}\n\n.hs-method.get    { background: rgba(74, 144, 217, 0.18);  color: #4a90d9; }\n.hs-method.post   { background: rgba(46, 160, 67, 0.18);   color: #2ea043; }\n.hs-method.put    { background: rgba(240, 173, 78, 0.18);  color: #f0ad4e; }\n.hs-method.delete { background: rgba(248, 81, 73, 0.18);   color: #f85149; }\n\n.hs-path {\n  color: var(--text-primary);\n  flex: 1;\n}\n\n.hs-caption {\n  font-size: 14px;\n  color: var(--text-secondary);\n  text-align: center;\n  margin: 0;\n  max-width: 460px;\n  line-height: 1.5;\n}\n\n/* Responsive: stack vertically on smaller screens */\n@media (max-width: 768px) {\n  .hero-showcase { max-width: 100%; }\n  .hs-split {\n    flex-direction: column;\n    height: auto;\n  }\n  .hs-canvas {\n    flex: none;\n    height: 240px;\n    border-right: none;\n    border-bottom: 1px solid var(--border-color);\n  }\n  .hs-api {\n    flex: none;\n    padding: 12px 14px 16px;\n  }\n  .hs-table { width: 130px; }\n  .hs-caption { font-size: 13px; }\n}\n\n/* ===== Live API Card (replaces project tree) ===== */\n.api-card {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.api-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  background: rgba(74, 144, 217, 0.06);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.api-globe {\n  display: inline-flex;\n  color: var(--text-secondary);\n}\n\n.api-url {\n  flex: 1;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-size: 11px;\n  color: var(--text-primary);\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.api-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  color: #2ea043;\n}\n\n.api-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #2ea043;\n  box-shadow: 0 0 0 2px rgba(46, 160, 67, 0.2);\n  animation: api-pulse 2s ease-in-out infinite;\n}\n\n@keyframes api-pulse {\n  0%, 100% { opacity: 1; box-shadow: 0 0 0 2px rgba(46, 160, 67, 0.2); }\n  50%      { opacity: 0.7; box-shadow: 0 0 0 4px rgba(46, 160, 67, 0.1); }\n}\n\n.api-card-body {\n  padding: 6px 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.api-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-size: 10.5px;\n}\n\n.api-method {\n  display: inline-block;\n  min-width: 38px;\n  text-align: center;\n  padding: 2px 5px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n}\n\n.api-method.get {\n  background: rgba(74, 144, 217, 0.18);\n  color: #4a90d9;\n}\n\n.api-method.post {\n  background: rgba(46, 160, 67, 0.18);\n  color: #2ea043;\n}\n\n.api-method.put {\n  background: rgba(240, 173, 78, 0.18);\n  color: #f0ad4e;\n}\n\n.api-method.delete {\n  background: rgba(248, 81, 73, 0.18);\n  color: #f85149;\n}\n\n.api-path {\n  color: var(--text-primary);\n  flex: 0 1 auto;\n}\n\n.api-label {\n  margin-left: auto;\n  font-family: inherit;\n  font-size: 9.5px;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.api-divider {\n  height: 1px;\n  background: var(--border-color);\n  margin: 4px 12px;\n  opacity: 0.5;\n}\n\n.vision-showcase.stacked .api-row {\n  font-size: 10.5px;\n  padding: 4px 12px;\n}\n\n.vision-showcase.stacked .api-url {\n  font-size: 11px;\n}\n\n.stacked-line {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  pointer-events: none;\n  opacity: 0.8;\n}\n\n/* Responsive: stack vertically on small screens */\n@media (max-width: 900px) {\n  .landing-hero.hero-two-col {\n    flex-direction: column;\n    gap: 32px;\n    padding: 40px 20px;\n    text-align: center;\n    align-items: stretch;\n  }\n  .hero-text-col {\n    max-width: 100%;\n    padding: 0;\n    align-items: center;\n  }\n  .hero-text-main {\n    align-items: center;\n    text-align: center;\n  }\n  .hero-two-col .hero-badge {\n    align-self: center;\n  }\n  .hero-two-col .hero-title,\n  .hero-two-col .hero-desc {\n    text-align: center;\n  }\n  .hero-two-col .hero-actions,\n  .hero-two-col .hero-langs {\n    justify-content: center;\n  }\n  .hero-visual-col {\n    max-width: 100%;\n    align-self: auto;\n    align-items: stretch;\n  }\n\n  /* Stacked showcase becomes vertical stack on mobile — left-aligned, compact */\n  .vision-showcase.stacked {\n    aspect-ratio: auto;\n    min-height: auto;\n    max-height: none;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    align-items: flex-start;\n    padding-left: 4px;\n    padding-right: 20px;\n  }\n  .stacked-schema,\n  .stacked-project {\n    position: static;\n    width: 100%;\n    max-width: 300px;\n    min-width: 0;\n    top: auto;\n    left: auto;\n    bottom: auto;\n    right: auto;\n  }\n  .stacked-line {\n    display: none;\n  }\n\n  /* Smaller text inside cards on mobile */\n  .vision-showcase.stacked .show-card {\n    padding: 8px;\n  }\n  .vision-showcase.stacked .pic-table-head {\n    padding: 3px 6px;\n    font-size: 8.5px;\n  }\n  .vision-showcase.stacked .pic-row {\n    padding: 2px 6px;\n    font-size: 8px;\n  }\n  .vision-showcase.stacked .pic-field-type {\n    font-size: 7px;\n  }\n  .vision-showcase.stacked .tree-card,\n  .vision-showcase.stacked .tree-row,\n  .vision-showcase.stacked .tree-label {\n    font-size: 8.5px;\n  }\n  .vision-showcase.stacked .tree-card {\n    padding: 8px 6px;\n  }\n}\n\n/* Hide desktop nav actions on mobile, show hamburger only */\n@media (max-width: 768px) {\n  .landing-nav-actions .lang-switcher,\n  .landing-nav-actions .menu-icon-btn,\n  .landing-nav-actions .landing-btn-primary {\n    display: none;\n  }\n\n  .mobile-nav-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 8px 4px;\n  }\n\n  .mobile-nav-row .lang-switcher {\n    display: flex;\n  }\n\n  .mobile-nav-row .menu-icon-btn {\n    display: flex;\n  }\n}\n\n.hero-badge {\n  padding: 6px 16px;\n  background: rgba(74, 144, 217, 0.1);\n  border: 1px solid rgba(74, 144, 217, 0.2);\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n  letter-spacing: 0.5px;\n}\n\n.hero-title {\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -1px;\n  color: var(--text-primary);\n}\n\n.hero-highlight {\n  background: linear-gradient(135deg, var(--accent), #7c3aed);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-desc {\n  font-size: 17px;\n  color: var(--text-secondary);\n  max-width: 560px;\n  line-height: 1.6;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.hero-btn-primary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 28px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.hero-btn-primary:hover {\n  background: var(--accent-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(74, 144, 217, 0.3);\n}\n\n.hero-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: transparent;\n  color: var(--text-primary);\n  border: 1.5px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.hero-btn-secondary:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  transform: translateY(-1px);\n}\n\n.hero-btn-outline {\n  padding: 12px 28px;\n  background: none;\n  border: 1.5px solid var(--border-color);\n  border-radius: 10px;\n  color: var(--text-primary);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.hero-btn-outline:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Features */\n.landing-features {\n  display: flex;\n  gap: 24px;\n  padding: 60px 40px 80px;\n  max-width: 1000px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.feature-card {\n  flex: 1;\n  padding: 28px 24px;\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  background: var(--bg-secondary);\n  transition: all 0.2s;\n}\n\n.feature-card:hover {\n  border-color: var(--accent);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0,0,0,0.08);\n}\n\n.feature-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(74, 144, 217, 0.1);\n  border-radius: 12px;\n  color: var(--accent);\n  margin-bottom: 16px;\n}\n\n.feature-card h3 {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: var(--text-primary);\n}\n\n.feature-card p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n/* Nav links */\n.landing-nav-links {\n  display: flex;\n  gap: 4px;\n}\n\n.nav-link {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 6px;\n  transition: all 0.15s;\n}\n\n.nav-link:hover {\n  color: var(--text-primary);\n  background: var(--bg-primary);\n}\n\n.mobile-menu-btn {\n  display: none;\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  cursor: pointer;\n  padding: 4px;\n}\n\n.mobile-nav-dropdown {\n  display: none;\n  flex-direction: column;\n  padding: 8px 16px 16px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.mobile-nav-link {\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 10px 12px;\n  font-size: 14px;\n  color: var(--text-primary);\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background 0.15s;\n}\n\n.mobile-nav-link:hover {\n  background: var(--bg-primary);\n}\n\n.mobile-nav-link.accent {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.mobile-nav-divider {\n  height: 1px;\n  background: var(--border-color);\n  margin: 4px 0;\n}\n\n/* Hero lang tags */\n.hero-langs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.hero-lang-tag {\n  padding: 4px 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.hero-lang-tag.more {\n  color: var(--accent);\n  border-color: var(--accent);\n  background: rgba(74, 144, 217, 0.05);\n}\n\n/* Sections */\n.landing-section {\n  padding: 80px 40px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.landing-section.alt-bg {\n  max-width: 100%;\n  background: var(--bg-secondary);\n}\n\n.landing-section.alt-bg > * {\n  max-width: 1100px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.section-badge {\n  display: inline-block;\n  padding: 4px 14px;\n  background: rgba(74, 144, 217, 0.1);\n  border: 1px solid rgba(74, 144, 217, 0.15);\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--accent);\n  margin-bottom: 12px;\n}\n\n.section-title {\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  margin-bottom: 12px;\n}\n\n.section-desc {\n  font-size: 15px;\n  color: var(--text-secondary);\n  max-width: 500px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* How it works */\n.how-steps {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 16px;\n}\n\n.how-step {\n  flex: 1;\n  max-width: 280px;\n  text-align: center;\n  padding: 24px 16px;\n}\n\n.how-step-num {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--accent);\n  color: #fff;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: 800;\n  margin-bottom: 16px;\n}\n\n.how-step-visual {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.how-step h3 {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.how-step p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n.how-step-arrow {\n  display: flex;\n  align-items: center;\n  padding-top: 100px;\n}\n\n/* Features grid v2 */\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.feature-card-v2 {\n  padding: 24px;\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  background: var(--bg-primary);\n  transition: all 0.2s;\n}\n\n.feature-card-v2:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);\n}\n\n.feature-card-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 800;\n  margin-bottom: 14px;\n}\n\n.feature-card-v2 h3 {\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.feature-card-v2 p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n/* Who grid */\n.who-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.who-card {\n  padding: 28px 20px;\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  background: var(--bg-secondary);\n  text-align: center;\n  transition: all 0.2s;\n}\n\n.who-card:hover {\n  border-color: var(--accent);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);\n}\n\n.who-emoji {\n  font-size: 32px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.who-card h3 {\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.who-card p {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n/* Contact */\n.contact-cards {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n}\n\n.contact-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 32px 40px;\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  background: var(--bg-primary);\n  text-decoration: none;\n  transition: all 0.2s;\n  min-width: 240px;\n}\n\n.contact-card:hover {\n  border-color: var(--accent);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);\n}\n\n.contact-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  margin-bottom: 4px;\n}\n\n.email-icon {\n  background: rgba(74, 144, 217, 0.1);\n  color: var(--accent);\n}\n\n.tg-icon {\n  background: rgba(46, 160, 67, 0.1);\n  color: #2ea043;\n}\n\n.contact-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.contact-value {\n  font-size: 14px;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n/* CTA */\n.landing-cta {\n  text-align: center;\n  padding: 80px 40px;\n}\n\n.landing-cta h2 {\n  font-size: 32px;\n  font-weight: 800;\n  margin-bottom: 12px;\n}\n\n.landing-cta p {\n  font-size: 16px;\n  color: var(--text-secondary);\n  margin-bottom: 24px;\n}\n\n.landing-cta .hero-btn-primary {\n  display: inline-flex;\n}\n\n/* Footer v2 */\n.landing-footer-v2 {\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n.footer-content {\n  display: flex;\n  gap: 60px;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 48px 40px 32px;\n}\n\n.footer-brand {\n  flex: 1;\n}\n\n.footer-brand p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-top: 8px;\n  line-height: 1.5;\n}\n\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.footer-links h4 {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.footer-links button,\n.footer-links a {\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none;\n  padding: 2px 0;\n  transition: color 0.15s;\n}\n\n.footer-links button:hover,\n.footer-links a:hover {\n  color: var(--accent);\n}\n\n.footer-bottom {\n  border-top: 1px solid var(--border-color);\n  padding: 16px 40px;\n  text-align: center;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.footer-bottom p {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n/* Scroll to top */\n.scroll-top-btn {\n  position: fixed;\n  bottom: 28px;\n  right: 28px;\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 500;\n  opacity: 0;\n  transform: translateY(20px) scale(0.8);\n  pointer-events: none;\n  transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n  box-shadow: 0 4px 16px rgba(74, 144, 217, 0.3);\n}\n\n.scroll-top-btn.visible {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  pointer-events: auto;\n}\n\n.scroll-top-btn:hover {\n  transform: translateY(-3px) scale(1.08);\n  box-shadow: 0 6px 24px rgba(74, 144, 217, 0.4);\n}\n\n.scroll-top-btn:active {\n  transform: translateY(0) scale(0.95);\n}\n\n/* ===== Home / Dashboard ===== */\n/* ===== Dashboard Sidebar ===== */\n.dash-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.dash-sidebar {\n  width: 220px;\n  min-width: 220px;\n  background: var(--bg-secondary);\n  border-right: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n              min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.dash-sidebar:not(.open) {\n  width: 48px;\n  min-width: 48px;\n  border-right: 1px solid var(--border-color);\n}\n\n.dash-sidebar-nav {\n  flex: 1;\n  padding: 16px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  white-space: nowrap;\n}\n\n.dash-nav-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.dash-nav-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--text-secondary);\n  padding: 0 12px;\n  margin-bottom: 6px;\n}\n\n.dash-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.12s;\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n}\n\n.dash-nav-item:hover {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.dash-nav-item.active {\n  background: rgba(74, 144, 217, 0.1);\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.dash-nav-item.new-project {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.dash-nav-item.new-project:hover {\n  background: rgba(74, 144, 217, 0.1);\n}\n\n.dash-nav-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dash-nav-badge {\n  margin-left: auto;\n  padding: 2px 6px;\n  background: linear-gradient(135deg, var(--accent), #8250df);\n  color: #fff;\n  font-size: 8px;\n  font-weight: 800;\n  letter-spacing: 0.8px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.dash-sidebar-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 10px 0;\n}\n\n.dash-sidebar-toggle {\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.dash-sidebar-toggle:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Collapsed sidebar */\n.dash-sidebar:not(.open) .dash-sidebar-header {\n  justify-content: center;\n  padding: 10px 0 0;\n}\n\n.dash-sidebar:not(.open) .dash-sidebar-nav {\n  padding: 12px 6px;\n  align-items: center;\n}\n\n.dash-sidebar:not(.open) .dash-nav-label {\n  display: none;\n}\n\n.dash-sidebar:not(.open) .dash-nav-text,\n.dash-sidebar:not(.open) .dash-nav-badge {\n  display: none;\n}\n\n.dash-sidebar:not(.open) .dash-nav-item {\n  justify-content: center;\n  padding: 9px;\n  width: 36px;\n  gap: 0;\n}\n\n.dash-main {\n  flex: 1;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n}\n\n.home-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.home-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 40px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n.home-nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Profile Button & Menu */\n.profile-wrapper {\n  position: relative;\n}\n\n.profile-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 2px solid var(--border-color);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.profile-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  transform: scale(1.05);\n}\n\n.admin-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 2px solid var(--border-color);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.admin-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  transform: scale(1.05);\n}\n\n.admin-btn.active {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: rgba(74, 144, 217, 0.08);\n}\n\n/* ===== Admin Page ===== */\n.admin-page {\n  padding: 24px 32px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.admin-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.admin-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.admin-signout-btn {\n  padding: 8px 14px;\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-signout-btn:hover {\n  color: var(--danger);\n  border-color: var(--danger);\n}\n\n.admin-locked {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 60px 20px;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.admin-locked .auth-submit {\n  width: auto;\n  padding: 10px 24px;\n}\n\n.admin-tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 2px solid var(--border-color);\n  margin-bottom: 16px;\n}\n\n.admin-tab {\n  padding: 10px 18px;\n  background: none;\n  border: none;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.15s;\n}\n\n.admin-tab:hover {\n  color: var(--text-primary);\n}\n\n.admin-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.admin-table-wrap {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.admin-table thead {\n  background: var(--bg-primary);\n}\n\n.admin-table th {\n  text-align: left;\n  padding: 12px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.admin-table td {\n  padding: 12px 16px;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.admin-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.admin-table tbody tr:hover {\n  background: var(--dropdown-hover);\n}\n\n.admin-table .admin-num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ===== Read-only editor ===== */\n.side-menu.read-only input,\n.side-menu.read-only select,\n.side-menu.read-only textarea,\n.side-menu.read-only .auto-gen-btn,\n.side-menu.read-only input[type=\"checkbox\"] {\n  pointer-events: none;\n  opacity: 0.7;\n  user-select: none;\n}\n\n.admin-view-banner {\n  position: fixed;\n  top: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  padding: 8px 18px;\n  background: rgba(74, 144, 217, 0.12);\n  border: 1px solid var(--accent);\n  border-radius: 999px;\n  color: var(--accent);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);\n}\n\n.admin-view-banner svg {\n  width: 14px;\n  height: 14px;\n}\n\n.admin-view-btn {\n  padding: 6px 12px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-view-btn:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n.admin-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.admin-badge.ok {\n  background: rgba(76, 175, 80, 0.12);\n  color: #4CAF50;\n}\n\n.admin-badge.warn {\n  background: rgba(248, 81, 73, 0.12);\n  color: var(--danger);\n}\n\n.admin-loading,\n.admin-empty {\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.admin-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-color);\n  flex-wrap: wrap;\n}\n\n.admin-pager-left,\n.admin-pager-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.admin-pager-size {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.admin-pager-size select {\n  padding: 5px 8px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.admin-pager-size select:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.home-pager {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  margin-top: 28px;\n  padding: 16px;\n}\n\n/* ===== Poster Page (for social media screenshots) ===== */\n.poster-page {\n  /* poster-specific accents */\n  --poster-accent: #58a6ff;\n  --poster-accent-2: #b392f0;\n  --poster-surface: rgba(32, 42, 62, 0.92);\n  --poster-border: rgba(88, 166, 255, 0.55);\n  --poster-text: #e6edf3;\n  --poster-text-dim: rgba(230, 237, 243, 0.6);\n\n  /* override global theme vars so VisionShowcase adopts dark poster palette */\n  --bg-primary: #0d1117;\n  --bg-secondary: rgba(22, 27, 34, 0.72);\n  --border-color: rgba(88, 166, 255, 0.22);\n  --text-primary: #e6edf3;\n  --text-secondary: rgba(230, 237, 243, 0.6);\n  --accent: #58a6ff;\n  --accent-hover: #79b8ff;\n  --node-header: rgba(88, 166, 255, 0.3);\n  --node-header-text: #a4c9ff;\n  --node-field-alt: rgba(88, 166, 255, 0.05);\n  --node-border: rgba(88, 166, 255, 0.18);\n  --dropdown-hover: rgba(88, 166, 255, 0.08);\n  --popup-bg: rgba(22, 27, 34, 0.85);\n\n  position: relative;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  background: radial-gradient(ellipse at top left, #1a2540 0%, #0d1117 45%, #05080e 100%);\n  color: var(--poster-text);\n  display: flex;\n  flex-direction: column;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  padding: 24px 44px;\n  box-sizing: border-box;\n}\n\n.poster-blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.poster-blob-1 {\n  top: -140px;\n  left: -100px;\n  width: 520px;\n  height: 520px;\n  background: radial-gradient(circle, rgba(88, 166, 255, 0.28) 0%, transparent 70%);\n}\n\n.poster-blob-2 {\n  bottom: -180px;\n  right: -140px;\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(179, 146, 240, 0.22) 0%, transparent 70%);\n}\n\n.poster-header {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Title row at top (single line) */\n.poster-title-row {\n  position: relative;\n  z-index: 1;\n  margin: 14px 0 0;\n  padding: 0;\n  font-size: clamp(26px, 3vw, 48px);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  color: var(--poster-text);\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.poster-title-accent {\n  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* Main area: stacked showcase (left, dominant) + compact checklist (right) */\n.poster-main-v3 {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  display: grid;\n  grid-template-columns: 2fr 0.65fr;\n  gap: 27px;\n  align-items: stretch;\n  min-height: 0;\n  padding: 20px 0;\n}\n\n/* Right column: checklist on top, Try it CTA at bottom */\n.poster-right-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 0;\n  margin-right: 56px;\n  padding-top: 2%;\n}\n\n.poster-right-col .poster-checklist {\n  margin-right: 0;\n}\n\n.poster-showcase-col {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 0;\n}\n\n/* \"1 click\" badge at the start of the kite line (just after schema) */\n.poster-click-badge {\n  position: absolute;\n  top: 13%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 999px;\n  color: #fff;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  box-shadow:\n    0 6px 18px rgba(88, 166, 255, 0.4),\n    0 0 0 4px rgba(88, 166, 255, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.22);\n  z-index: 3;\n  white-space: nowrap;\n}\n\n.poster-click-badge svg {\n  width: 12px;\n  height: 12px;\n  color: #fff176;\n  filter: drop-shadow(0 0 3px rgba(255, 241, 118, 0.75));\n}\n\n.poster-showcase-col .vision-showcase.stacked {\n  max-width: none;\n  width: 100%;\n  height: 100%;\n  aspect-ratio: auto;\n  max-height: none;\n  min-height: 0;\n}\n\n/* Cards sized for poster — schema narrower/higher, project bigger/lower */\n.poster-showcase-col .stacked-schema {\n  width: 32%;\n  top: 2%;\n}\n\n.poster-showcase-col .stacked-project {\n  width: 34%;\n  right: 8%;\n  bottom: 0;\n}\n\n.poster-showcase-col .show-card {\n  background: #e9eef5;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  box-shadow:\n    0 24px 56px rgba(0, 0, 0, 0.45),\n    0 0 0 1px rgba(255, 255, 255, 0.04);\n  padding: 18px;\n}\n\n/* Schema table text — readable on screenshots */\n.poster-showcase-col .vision-showcase.stacked .pic-table {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);\n}\n\n.poster-showcase-col .vision-showcase.stacked .pic-table-head {\n  padding: 10px 14px;\n  font-size: 17px;\n  font-weight: 800;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  color: #ffffff;\n  letter-spacing: 0.3px;\n  border-bottom: none;\n}\n\n.poster-showcase-col .vision-showcase.stacked .pic-row {\n  padding: 8px 14px;\n  font-size: 15px;\n}\n\n.poster-showcase-col .vision-showcase.stacked .pic-row:nth-child(odd) {\n  background: #f8fafc;\n}\n\n.poster-showcase-col .vision-showcase.stacked .pic-field-name {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.poster-showcase-col .vision-showcase.stacked .pic-row.is-key .pic-field-name {\n  color: #d97706;\n  font-weight: 800;\n}\n\n.poster-showcase-col .vision-showcase.stacked .pic-row.is-fk .pic-field-name {\n  color: #e11d48;\n  font-weight: 700;\n}\n\n.poster-showcase-col .vision-showcase.stacked .pic-field-type {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 600;\n}\n\n/* Schema tables layout: User + Comment on top row, Post centered below */\n.poster-showcase-col .vision-showcase.stacked .diagram-tables {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas:\n    \"user comment\"\n    \"post post\";\n  gap: 26px 22px;\n  align-items: start;\n  width: 100%;\n}\n\n.poster-showcase-col .vision-showcase.stacked .diagram-tables > .pic-table:nth-child(1) {\n  grid-area: user;\n  width: 100%;\n  align-self: auto;\n}\n\n.poster-showcase-col .vision-showcase.stacked .diagram-tables > .pic-table:nth-child(2) {\n  grid-area: post;\n  width: 60%;\n  justify-self: center;\n  align-self: auto;\n}\n\n.poster-showcase-col .vision-showcase.stacked .diagram-tables > .pic-table:nth-child(3) {\n  grid-area: comment;\n  width: 100%;\n  align-self: auto;\n}\n\n/* Project tree — bright card */\n.poster-showcase-col .vision-showcase.stacked .tree-card {\n  font-size: 15px;\n  padding: 16px 14px;\n  background: #e9eef5;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  color: #0f172a;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);\n}\n\n.poster-showcase-col .vision-showcase.stacked .tree-row {\n  padding: 4px 6px;\n  font-size: 15px;\n  color: #0f172a;\n}\n\n.poster-showcase-col .vision-showcase.stacked .tree-row.accent {\n  color: #8b5cf6;\n  font-weight: 700;\n}\n\n.poster-showcase-col .vision-showcase.stacked .tree-label {\n  font-size: 15px;\n}\n\n.poster-showcase-col .vision-showcase.stacked .tree-icon.folder {\n  color: #3b82f6;\n}\n\n.poster-showcase-col .vision-showcase.stacked .tree-icon.file {\n  color: #94a3b8;\n}\n\n.poster-showcase-col .vision-showcase.stacked .show-label {\n  font-size: 13px;\n  letter-spacing: 1.2px;\n  margin-bottom: 12px;\n  color: rgba(230, 237, 243, 0.8);\n  font-weight: 700;\n}\n\n.poster-showcase-col .vision-showcase.stacked .show-card {\n  padding: 16px;\n}\n\n/* ----- Checklist column — pill/chip layout (not table-like) ----- */\n.poster-checklist {\n  padding: 8px 4px;\n  margin-right: 56px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  align-content: center;\n}\n\n.poster-checklist-title {\n  font-size: 12px;\n  font-weight: 900;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  position: relative;\n  padding-left: 18px;\n  background: linear-gradient(135deg, #79b8ff 0%, #c49dff 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.poster-checklist-title::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);\n  box-shadow: 0 0 16px rgba(88, 166, 255, 0.9);\n}\n\n.poster-checklist-items {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.poster-check-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px 8px 10px;\n  background: #e9eef5;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 999px;\n  font-size: 13px;\n  color: #0f172a;\n  font-weight: 700;\n  transition: none;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);\n}\n\n.poster-check-box {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.5);\n}\n\n.poster-check-box svg {\n  width: 10px;\n  height: 10px;\n}\n\n.poster-check-label {\n  line-height: 1;\n  letter-spacing: 0.2px;\n}\n\n/* ----- Footer CTA (inside right column) ----- */\n.poster-footer-cta {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 18px;\n  background: rgba(88, 166, 255, 0.1);\n  border: 1px solid rgba(88, 166, 255, 0.32);\n  border-radius: 999px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 8px 24px rgba(88, 166, 255, 0.2);\n}\n\n.poster-footer-try {\n  font-size: 16px;\n  font-weight: 700;\n  color: rgba(230, 237, 243, 0.9);\n  letter-spacing: 0.3px;\n}\n\n.poster-footer-hand {\n  font-size: 19px;\n  line-height: 1;\n  filter: drop-shadow(0 0 5px rgba(88, 166, 255, 0.5));\n}\n\n.poster-footer-domain {\n  font-family: 'Fira Code', 'SF Mono', Menlo, Consolas, monospace;\n  font-size: 17px;\n  font-weight: 800;\n  background: linear-gradient(135deg, var(--poster-accent) 0%, var(--poster-accent-2) 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: 0.5px;\n}\n\n/* ===== Templates Page ===== */\n.templates-standalone {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  display: flex;\n  flex-direction: column;\n}\n\n.templates-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 32px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.templates-nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.templates-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px 32px 40px;\n  width: 100%;\n}\n\n.templates-hero {\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.templates-hero-title {\n  font-size: clamp(26px, 3vw, 38px);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 8px;\n  line-height: 1.1;\n}\n\n.templates-hero-sub {\n  font-size: clamp(13px, 1.1vw, 16px);\n  color: var(--text-secondary);\n  max-width: 560px;\n  margin: 0 auto;\n  line-height: 1.5;\n}\n\n.templates-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 18px;\n}\n\n.template-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 14px;\n  padding: 20px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: all 0.2s;\n  position: relative;\n  overflow: hidden;\n}\n\n.template-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, transparent, currentColor, transparent);\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.template-card:hover {\n  transform: translateY(-3px);\n  border-color: var(--accent);\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.16);\n}\n\n.template-card-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.template-card-icon svg {\n  width: 26px;\n  height: 26px;\n}\n\n.template-card-name {\n  font-size: 19px;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n  margin: 0;\n}\n\n.template-card-desc {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.template-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: auto;\n}\n\n.template-meta-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 11px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.template-card-features {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.template-feature-chip {\n  padding: 4px 10px;\n  background: rgba(74, 144, 217, 0.1);\n  border: 1px solid rgba(74, 144, 217, 0.25);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--accent);\n}\n\n.template-card-cta {\n  padding: 9px 16px;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  letter-spacing: 0.2px;\n}\n\n.template-card-cta:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  filter: brightness(1.05);\n}\n\n/* ===== Custom template badge in TemplatesPage ===== */\n.template-custom-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 8px;\n  background: rgba(240, 173, 78, 0.15);\n  border: 1px solid rgba(240, 173, 78, 0.4);\n  border-radius: 999px;\n  color: #f0ad4e;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n/* ===== Admin Templates ===== */\n.admin-templates-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n/* ===== Template Editor (admin) ===== */\n.template-editor-bar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.template-editor-back {\n  width: 30px;\n  height: 30px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.template-editor-back:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.template-editor-fields {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.template-editor-input {\n  padding: 7px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  flex: 0 0 200px;\n  transition: border-color 0.15s;\n}\n\n.template-editor-input.wide {\n  flex: 1 1 auto;\n  font-weight: 500;\n}\n\n.template-editor-input:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.template-editor-color {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: none;\n  cursor: pointer;\n  padding: 2px;\n}\n\n.template-editor-select {\n  padding: 7px 10px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.template-editor-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.template-editor-saved {\n  font-size: 12px;\n  font-weight: 600;\n  color: #2ea043;\n}\n\n.template-editor-error {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--danger);\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.template-editor-save {\n  padding: 8px 18px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 7px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.template-editor-save:hover:not(:disabled) {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n.template-editor-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.template-editor-main {\n  height: calc(100vh - 52px);\n}\n\n/* Push floating + Table / + Enum buttons below the template editor top bar */\n.template-editor-page .floating-add-buttons {\n  top: 64px;\n}\n\n/* ===== Guest Viewer Banner ===== */\n.guest-banner {\n  position: fixed;\n  top: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 16px 10px 18px;\n  background: var(--popup-bg);\n  border: 1px solid var(--accent);\n  border-radius: 999px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);\n}\n\n.guest-banner-text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.guest-banner-text svg {\n  color: var(--accent);\n}\n\n.guest-banner-cta {\n  padding: 6px 14px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.guest-banner-cta:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n/* ===== Editor Toast ===== */\n.editor-toast {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 20px;\n  background: var(--popup-bg);\n  color: var(--text-primary);\n  border: 1px solid var(--danger);\n  border-left: 4px solid var(--danger);\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);\n  animation: toastSlideIn 0.25s ease-out, toastFadeOut 0.35s ease-in 3.15s forwards;\n  max-width: 92vw;\n}\n\n.editor-toast svg {\n  flex-shrink: 0;\n  color: var(--danger);\n}\n\n@keyframes toastSlideIn {\n  from { opacity: 0; transform: translate(-50%, -12px); }\n  to { opacity: 1; transform: translate(-50%, 0); }\n}\n\n@keyframes toastFadeOut {\n  from { opacity: 1; transform: translate(-50%, 0); }\n  to { opacity: 0; transform: translate(-50%, -12px); }\n}\n\n/* ===== Vision Page (single viewport) ===== */\n.vision-single {\n  height: 100vh;\n  overflow: hidden;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  display: flex;\n  flex-direction: column;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.vision-nav-thin {\n  flex-shrink: 0;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 28px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.vision-cta-small {\n  padding: 7px 14px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.vision-cta-small:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n.vision-stage {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 24px;\n  gap: 28px;\n  min-height: 0;\n}\n\n.vision-heading {\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.vision-big-title {\n  font-size: clamp(36px, 5vw, 56px);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.05;\n  margin-bottom: 8px;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.vision-big-sub {\n  font-size: clamp(14px, 1.4vw, 18px);\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.vision-showcase {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(20px, 4vw, 48px);\n  width: 100%;\n  max-width: 1280px;\n  min-height: 0;\n}\n\n.show-side {\n  flex: 1;\n  max-width: 440px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  min-height: 0;\n}\n\n.show-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.show-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 14px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);\n  padding: 18px;\n  position: relative;\n  overflow: hidden;\n}\n\n.diagram-card {\n  min-height: 320px;\n}\n\n.diagram-tables {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  position: relative;\n  z-index: 1;\n}\n\n.diagram-tables > .pic-table:nth-child(1) { align-self: flex-start; width: 62%; }\n.diagram-tables > .pic-table:nth-child(2) { align-self: center; width: 68%; }\n.diagram-tables > .pic-table:nth-child(3) { align-self: flex-end; width: 58%; }\n\n.pic-table {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  overflow: hidden;\n  font-size: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.pic-table-head {\n  padding: 6px 10px;\n  background: var(--node-header);\n  color: var(--node-header-text);\n  font-weight: 700;\n  font-size: 12px;\n  letter-spacing: 0.2px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.pic-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px;\n  font-size: 11.5px;\n}\n\n.pic-row:nth-child(odd) {\n  background: var(--node-field-alt);\n}\n\n.pic-field-name {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.pic-field-type {\n  color: var(--text-secondary);\n  font-family: 'Fira Code', 'SF Mono', Menlo, Consolas, monospace;\n  font-size: 10.5px;\n}\n\n.pic-row.is-key .pic-field-name {\n  color: var(--accent);\n  font-weight: 700;\n}\n\n.pic-row.is-fk .pic-field-name {\n  color: #f0ad4e;\n  font-weight: 600;\n}\n\n.diagram-lines {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 0;\n  opacity: 0.6;\n}\n\n.show-arrow {\n  flex-shrink: 0;\n  width: clamp(70px, 10vw, 130px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  color: var(--accent);\n}\n\n.show-arrow svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.show-arrow-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--accent);\n  line-height: 1;\n}\n\n.tree-card {\n  font-family: 'Fira Code', 'SF Mono', Menlo, Consolas, monospace;\n  font-size: 12.5px;\n  padding: 14px 10px;\n  min-height: 320px;\n  max-height: 50vh;\n  overflow: hidden;\n}\n\n.tree-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 6px;\n  border-radius: 4px;\n  white-space: nowrap;\n  color: var(--text-primary);\n}\n\n.tree-row.accent {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.tree-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  color: var(--text-secondary);\n}\n\n.tree-icon.folder {\n  color: var(--accent);\n}\n\n.tree-icon.file {\n  color: var(--text-secondary);\n}\n\n.tree-label {\n  font-size: 12px;\n}\n\n.vision-cta-row {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.vision-cta-big {\n  padding: 14px 38px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 6px 22px rgba(74, 144, 217, 0.3);\n}\n\n.vision-cta-big:hover {\n  background: var(--accent-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 28px rgba(74, 144, 217, 0.4);\n}\n\n.vision-cta-hint {\n  font-size: 12px;\n  color: var(--text-secondary);\n  letter-spacing: 0.3px;\n}\n\n@media (max-width: 900px) {\n  .vision-single { height: auto; min-height: 100vh; overflow: auto; }\n  .vision-showcase { flex-direction: column; gap: 20px; }\n  .show-arrow { width: 60px; transform: rotate(90deg); }\n  .show-side { max-width: 100%; width: 100%; }\n  .tree-card, .diagram-card { min-height: auto; }\n}\n\n.admin-page-btn {\n  padding: 7px 14px;\n  background: transparent;\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-page-btn:hover:not(:disabled) {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.admin-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.admin-page-info {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.admin-login-hint {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin-bottom: 4px;\n}\n\n.admin-resend-btn {\n  align-self: center;\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 4px 8px;\n}\n\n.admin-resend-btn:disabled {\n  color: var(--text-secondary);\n  cursor: not-allowed;\n}\n\n.auth-info {\n  padding: 8px 12px;\n  background: rgba(76, 175, 80, 0.1);\n  border: 1px solid rgba(76, 175, 80, 0.3);\n  border-radius: 8px;\n  color: #4CAF50;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.profile-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}\n\n.profile-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 200px;\n  background: var(--popup-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 14px;\n  padding: 6px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  animation: slideDown 0.15s ease-out;\n}\n\n.profile-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.12s;\n}\n\n.profile-menu-item:hover {\n  background: var(--bg-primary);\n}\n\n.profile-menu-item.danger {\n  color: var(--danger);\n}\n\n.profile-menu-item.danger:hover {\n  background: rgba(248, 81, 73, 0.08);\n}\n\n.profile-menu-divider {\n  height: 1px;\n  background: var(--border-color);\n  margin: 4px 10px;\n}\n\n/* ===== Profile Page ===== */\n.profile-content {\n  max-width: 520px;\n  margin: 0 auto;\n  padding: 32px 40px;\n}\n\n.profile-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 24px;\n  transition: color 0.15s;\n}\n\n.profile-back:hover {\n  color: var(--accent);\n}\n\n.profile-title {\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  margin-bottom: 24px;\n}\n\n.profile-message {\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 20px;\n  animation: slideDown 0.2s ease-out;\n}\n\n.profile-message.success {\n  background: rgba(46, 160, 67, 0.1);\n  border: 1px solid rgba(46, 160, 67, 0.25);\n  color: #2ea043;\n}\n\n.profile-message.error {\n  background: rgba(248, 81, 73, 0.1);\n  border: 1px solid rgba(248, 81, 73, 0.25);\n  color: #f85149;\n}\n\n.profile-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 20px;\n}\n\n.profile-card-title {\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 18px;\n  color: var(--text-primary);\n}\n\n.profile-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.profile-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.profile-field label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-secondary);\n}\n\n.profile-field input {\n  padding: 10px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.profile-field input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);\n}\n\n.profile-divider {\n  height: 1px;\n  background: var(--border-color);\n  margin: 6px 0;\n}\n\n.profile-card-subtitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.profile-hint {\n  font-size: 11px;\n  color: var(--text-secondary);\n  font-style: italic;\n  margin-top: -4px;\n}\n\n/* Verification */\n.profile-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.verify-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 6px;\n}\n\n.verify-badge.verified {\n  color: #2ea043;\n  background: rgba(46, 160, 67, 0.1);\n}\n\n.verify-badge.unverified {\n  color: #f85149;\n  background: rgba(248, 81, 73, 0.1);\n}\n\n.verify-prompt {\n  margin-top: 6px;\n  padding: 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  animation: slideDown 0.2s ease-out;\n}\n\n.verify-prompt-text {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin-bottom: 10px;\n}\n\n.verify-send-btn {\n  padding: 8px 16px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.verify-send-btn:hover:not(:disabled) {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n.verify-send-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.verify-code-box {\n  margin-top: 6px;\n  padding: 14px;\n  background: var(--bg-primary);\n  border: 1px solid var(--accent);\n  border-radius: 10px;\n  animation: slideDown 0.2s ease-out;\n}\n\n.verify-code-text {\n  font-size: 12px;\n  color: var(--text-secondary);\n  margin-bottom: 10px;\n}\n\n.verify-code-row {\n  display: flex;\n  gap: 8px;\n}\n\n.verify-code-input {\n  flex: 1;\n  padding: 9px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 4px;\n  text-align: center;\n}\n\n.verify-code-input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);\n}\n\n.verify-confirm-btn {\n  padding: 9px 20px;\n  background: #2ea043;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.verify-confirm-btn:hover:not(:disabled) {\n  background: #278c38;\n}\n\n.verify-confirm-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.verify-resend {\n  background: none;\n  border: none;\n  color: var(--accent);\n  font-size: 11px;\n  cursor: pointer;\n  margin-top: 8px;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.verify-resend:hover {\n  color: var(--accent-hover);\n}\n\n.verify-resend:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.verify-msg {\n  margin-top: 6px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  animation: slideDown 0.15s ease-out;\n}\n\n.verify-msg.success {\n  background: rgba(46, 160, 67, 0.1);\n  color: #2ea043;\n}\n\n.verify-msg.error {\n  background: rgba(248, 81, 73, 0.1);\n  color: #f85149;\n}\n\n.profile-save-btn {\n  padding: 11px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 4px;\n  align-self: flex-start;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.profile-save-btn:hover:not(:disabled) {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.3);\n}\n\n.profile-save-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.home-content {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 32px 40px;\n}\n\n.home-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.home-title {\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n}\n\n.home-subtitle {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-top: 4px;\n}\n\n.home-new-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 20px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.home-new-btn:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(74, 144, 217, 0.3);\n}\n\n.home-tabs {\n  display: flex;\n  border-bottom: 2px solid var(--border-color);\n  margin-bottom: 24px;\n}\n\n.home-tab {\n  padding: 10px 20px;\n  background: none;\n  border: none;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s;\n}\n\n.home-tab:hover {\n  color: var(--text-primary);\n}\n\n.home-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.home-loading {\n  text-align: center;\n  padding: 40px;\n  color: var(--text-secondary);\n}\n\n.home-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.home-empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--text-secondary);\n}\n\n.home-empty p {\n  margin-bottom: 16px;\n  font-size: 15px;\n}\n\n.home-empty-btn {\n  padding: 10px 24px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.home-empty-btn:hover {\n  background: var(--accent-hover);\n}\n\n/* Project Cards */\n.project-card {\n  padding: 20px;\n  border: 1px solid var(--border-color);\n  border-radius: 14px;\n  background: var(--bg-secondary);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: all 0.2s;\n}\n\n.project-card:hover {\n  border-color: var(--accent);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0,0,0,0.06);\n}\n\n.project-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n\n.project-delete-btn {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 50%;\n  color: var(--text-secondary);\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.project-card:hover .project-delete-btn {\n  opacity: 0.5;\n}\n\n.project-delete-btn:hover {\n  opacity: 1 !important;\n  color: var(--danger);\n  border-color: var(--danger);\n  background: rgba(248, 81, 73, 0.1);\n}\n\n/* ===== Delete Confirm Modal ===== */\n.confirm-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--popup-overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.15s ease-out;\n}\n\n.confirm-modal {\n  background: var(--popup-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 20px;\n  width: 360px;\n  padding: 32px 28px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 10px;\n  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.3);\n  animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.confirm-icon {\n  margin-bottom: 2px;\n}\n\n.confirm-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.confirm-desc {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n.confirm-actions {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.confirm-cancel {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.confirm-cancel:hover {\n  background: var(--bg-primary);\n  border-color: var(--text-secondary);\n}\n\n.confirm-delete {\n  flex: 1;\n  padding: 10px;\n  border: none;\n  border-radius: 10px;\n  background: #f85149;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.confirm-delete:hover:not(:disabled) {\n  background: #da3633;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(248, 81, 73, 0.3);\n}\n\n.confirm-delete:disabled,\n.confirm-cancel:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.project-card-icon {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(74, 144, 217, 0.1);\n  border-radius: 8px;\n  color: var(--accent);\n}\n\n.draft-icon {\n  background: rgba(240, 173, 78, 0.1);\n  color: #f0ad4e;\n}\n\n.project-badge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.project-badge.active {\n  background: rgba(46, 160, 67, 0.1);\n  color: #2ea043;\n}\n\n.project-badge.expired {\n  background: rgba(248, 81, 73, 0.1);\n  color: #f85149;\n}\n\n.project-badge.draft {\n  background: rgba(240, 173, 78, 0.1);\n  color: #f0ad4e;\n}\n\n.project-card-name {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.project-card-date {\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n\n.project-card-actions {\n  margin-top: auto;\n  padding-top: 6px;\n}\n\n.project-card-actions.two-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.project-action-btn {\n  width: 100%;\n  padding: 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  text-align: center;\n}\n\n.project-action-btn.download {\n  background: rgba(46, 160, 67, 0.1);\n  color: #2ea043;\n  border: 1px solid rgba(46, 160, 67, 0.2);\n}\n\n.project-action-btn.download:hover {\n  background: #2ea043;\n  color: #fff;\n}\n\n.project-action-btn.edit {\n  background: rgba(74, 144, 217, 0.1);\n  color: var(--accent);\n  border: 1px solid rgba(74, 144, 217, 0.2);\n}\n\n.project-action-btn.edit:hover {\n  background: var(--accent);\n  color: #fff;\n}\n\n/* ===== Feedback Banner Compact (Dashboard) ===== */\n.feedback-banner-compact {\n  padding: 12px 18px;\n  background: linear-gradient(135deg, rgba(74, 144, 217, 0.06) 0%, rgba(130, 80, 223, 0.06) 100%);\n  border: 1px solid rgba(74, 144, 217, 0.15);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-bottom: 20px;\n}\n\n.feedback-banner-compact:hover {\n  background: linear-gradient(135deg, rgba(74, 144, 217, 0.1) 0%, rgba(130, 80, 223, 0.1) 100%);\n  border-color: var(--accent);\n}\n\n.feedback-banner-compact:hover svg {\n  transform: translateX(3px);\n}\n\n.feedback-banner-compact svg {\n  color: var(--accent);\n  flex-shrink: 0;\n  transition: transform 0.2s;\n}\n\n.feedback-banner-compact .feedback-banner-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.feedback-banner-badge {\n  padding: 3px 8px;\n  background: linear-gradient(135deg, var(--accent), #8250df);\n  color: #fff;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 1px;\n  border-radius: 5px;\n  flex-shrink: 0;\n}\n\n.feedback-banner-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.feedback-banner-desc {\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n\n/* ===== Feedback Page ===== */\n.feedback-header {\n  margin-bottom: 8px;\n}\n\n.feedback-form {\n  margin-bottom: 24px;\n  animation: slideDown 0.2s ease-out;\n}\n\n.feedback-form-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.feedback-about-options {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.feedback-about-btn {\n  padding: 7px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.feedback-about-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.feedback-about-btn.active {\n  background: rgba(74, 144, 217, 0.1);\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.feedback-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.feedback-textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);\n}\n\n.feedback-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.feedback-card {\n  padding: 20px;\n  border: 1px solid var(--border-color);\n  border-radius: 14px;\n  background: var(--bg-secondary);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: all 0.2s;\n}\n\n.feedback-card:hover {\n  border-color: var(--accent);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(0,0,0,0.05);\n}\n\n.feedback-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.feedback-about-tag {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.feedback-about-tag.platform {\n  background: rgba(74, 144, 217, 0.1);\n  color: var(--accent);\n}\n\n.feedback-about-tag.generated_project {\n  background: rgba(46, 160, 67, 0.1);\n  color: #2ea043;\n}\n\n.feedback-about-tag.other {\n  background: rgba(240, 173, 78, 0.1);\n  color: #f0ad4e;\n}\n\n.feedback-delete-btn {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  color: var(--text-secondary);\n  cursor: pointer;\n  opacity: 0;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.feedback-card:hover .feedback-delete-btn {\n  opacity: 0.5;\n}\n\n.feedback-delete-btn:hover {\n  opacity: 1 !important;\n  color: var(--danger);\n  border-color: var(--danger);\n  background: rgba(248, 81, 73, 0.1);\n}\n\n.feedback-card-text {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--text-primary);\n}\n\n.feedback-card-date {\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n\n.feedback-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.feedback-page-btn {\n  padding: 8px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.feedback-page-btn:hover:not(:disabled) {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.feedback-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.feedback-page-info {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n/* ===== Editor extras ===== */\n.save-indicator {\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  z-index: 500;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.save-indicator.saving {\n  opacity: 1;\n  background: rgba(74, 144, 217, 0.15);\n  color: var(--accent);\n  border: 1px solid rgba(74, 144, 217, 0.3);\n}\n\n.save-indicator.saved {\n  opacity: 1;\n  background: rgba(46, 160, 67, 0.15);\n  color: #2ea043;\n  border: 1px solid rgba(46, 160, 67, 0.3);\n}\n\n.save-indicator.error {\n  opacity: 1;\n  background: rgba(248, 81, 73, 0.15);\n  color: #f85149;\n  border: 1px solid rgba(248, 81, 73, 0.3);\n}\n\n/* ===== Floating Add Buttons ===== */\n.floating-add-buttons {\n  position: fixed;\n  top: 12px;\n  right: 56px;\n  display: flex;\n  gap: 6px;\n  z-index: 500;\n}\n\n/* Top-left project name input — shifts right when toolbar opens */\n.floating-project-name {\n  position: fixed;\n  top: 12px;\n  left: 56px;\n  z-index: 500;\n  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.floating-project-name.toolbar-open {\n  left: 312px;\n}\n\n.floating-project-name-input {\n  background: var(--bg-secondary);\n  backdrop-filter: blur(12px);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n  width: 200px;\n  outline: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.floating-project-name-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 2px rgba(74, 144, 217, 0.15);\n}\n\n.floating-project-name-input::placeholder {\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .floating-project-name-input {\n    width: 140px;\n  }\n}\n\n.floating-add-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 14px;\n  background: var(--bg-secondary);\n  backdrop-filter: blur(12px);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  color: var(--text-primary);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n\n.floating-add-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n}\n\n.floating-add-btn.enum {\n  color: var(--text-secondary);\n}\n\n.floating-add-btn.enum:hover {\n  border-color: #f0ad4e;\n  color: #f0ad4e;\n}\n\n.back-to-home {\n  position: fixed;\n  top: 12px;\n  right: 16px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  z-index: 500;\n  transition: all 0.15s;\n}\n\n.back-to-home:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.back-to-home.sidebar-open {\n  right: 236px;\n  transition: right 0.2s;\n}\n\n.floating-add-buttons.sidebar-open {\n  right: 276px;\n  transition: right 0.2s;\n}\n\n/* ===== Side Menu ===== */\n.side-menu {\n  width: 300px;\n  height: 100vh;\n  background: var(--bg-sidebar);\n  border-right: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-color) transparent;\n}\n\n.side-menu::-webkit-scrollbar {\n  width: 4px;\n}\n\n.side-menu::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 4px;\n}\n\n.side-menu.collapsed {\n  width: 48px;\n  overflow: hidden;\n  align-items: center;\n  padding-top: 12px;\n}\n\n.menu-expand-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-secondary);\n  font-size: 18px;\n  padding: 10px;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.menu-expand-btn:hover {\n  color: var(--accent);\n  background: var(--bg-primary);\n  transform: scale(1.05);\n}\n\n/* Header */\n.menu-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n  background: var(--bg-sidebar);\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.menu-header h3 {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--accent);\n  letter-spacing: -0.3px;\n}\n\n.menu-brand-link {\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n\n.menu-brand-link:hover {\n  opacity: 0.7;\n}\n\n.menu-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.menu-icon-btn {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  font-size: 16px;\n  color: var(--text-primary);\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 8px;\n  line-height: 1;\n  transition: all 0.2s;\n}\n\n.menu-icon-btn:hover {\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n/* Sections */\n.menu-section {\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.menu-section:last-child {\n  border-bottom: none;\n}\n\n/* Collapsible section header */\n.menu-section-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 6px 8px;\n  margin: -4px -8px;\n  border-radius: 8px;\n  user-select: none;\n  transition: background 0.15s;\n}\n\n.menu-section-header:hover {\n  background: var(--bg-primary);\n}\n\n.menu-section-icon {\n  font-size: 15px;\n  line-height: 1;\n}\n\n.menu-section-title-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  flex: 1;\n  letter-spacing: 0.2px;\n}\n\n.menu-chevron {\n  font-size: 9px;\n  color: var(--text-secondary);\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.menu-chevron.open {\n  transform: rotate(90deg);\n}\n\n.menu-section-body {\n  margin-top: 10px;\n  padding: 14px;\n  background: var(--bg-primary);\n  border-radius: 15px;\n  border: 1px solid var(--border-color);\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.menu-section-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--text-secondary);\n  margin-bottom: 12px;\n}\n\n/* Add buttons */\n.menu-row {\n  display: flex;\n  gap: 8px;\n}\n\n.menu-btn {\n  flex: 1;\n  padding: 10px;\n  border: 1.5px dashed var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.menu-btn:hover:not(:disabled) {\n  border-color: var(--accent);\n  color: var(--accent);\n  border-style: solid;\n  background: var(--bg-secondary);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.menu-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.menu-hint {\n  font-size: 11px;\n  color: var(--danger);\n  margin-top: 8px;\n  font-style: italic;\n  text-align: center;\n}\n\n.select-required {\n  border-color: var(--accent) !important;\n  box-shadow: 0 0 0 2px rgba(74, 144, 217, 0.15);\n}\n\n/* Form fields */\n.menu-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 14px;\n}\n\n.menu-field:last-child {\n  margin-bottom: 0;\n}\n\n.menu-field label {\n  font-size: 11px;\n  color: var(--text-secondary);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.menu-field select,\n.menu-field input {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.menu-field select {\n  cursor: pointer;\n}\n\n.menu-field input:focus,\n.menu-field select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);\n}\n\n.menu-field input::placeholder {\n  color: var(--text-secondary);\n  opacity: 0.6;\n}\n\n/* JWT auto-generate */\n.input-with-btn {\n  display: flex;\n  gap: 6px;\n}\n\n.input-with-btn input {\n  flex: 1;\n  min-width: 0;\n}\n\n.auto-gen-btn {\n  padding: 6px 12px;\n  border: 1.5px solid var(--accent);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--accent);\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s;\n  letter-spacing: 0.3px;\n}\n\n.auto-gen-btn:hover {\n  background: var(--accent);\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.auto-gen-hint {\n  font-size: 10px;\n  color: var(--accent);\n  font-style: italic;\n  margin-top: 2px;\n  padding-left: 2px;\n}\n\n/* Features grid */\n.menu-features {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.menu-feature-item {\n  width: calc(50% - 2px);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  cursor: pointer;\n  color: var(--text-primary);\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  transition: all 0.15s;\n}\n\n.menu-feature-item:hover {\n  background: var(--bg-primary);\n  border-color: var(--border-color);\n}\n\n.menu-feature-item.disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.menu-feature-item input[type=\"checkbox\"] {\n  accent-color: var(--accent);\n  cursor: pointer;\n  width: 15px;\n  height: 15px;\n}\n\n.menu-feature-item span {\n  text-transform: capitalize;\n  font-weight: 500;\n}\n\n/* Action buttons */\n.menu-actions {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: auto;\n  position: sticky;\n  bottom: 0;\n  background: var(--bg-sidebar);\n  border-top: 1px solid var(--border-color);\n}\n\n.menu-action-btn {\n  padding: 10px 16px;\n  border: 1.5px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.menu-action-btn.preview {\n  background: transparent;\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n.menu-action-btn.preview:hover {\n  background: var(--accent);\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(74, 144, 217, 0.2);\n}\n\n.menu-action-btn.generate {\n  background: var(--accent);\n  color: #fff;\n  border-color: var(--accent);\n}\n\n.menu-action-btn.generate:hover:not(:disabled) {\n  background: var(--accent-hover);\n  border-color: var(--accent-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.3);\n}\n\n.menu-action-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* ===== Generation Result Modal ===== */\n.gen-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--popup-overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.15s ease-out;\n}\n\n.gen-modal {\n  background: var(--popup-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 20px;\n  width: 400px;\n  padding: 40px 36px 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.3);\n  animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes modalPop {\n  from { opacity: 0; transform: scale(0.85) translateY(20px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.gen-modal-icon {\n  margin-bottom: 4px;\n}\n\n.success-icon svg {\n  animation: checkDraw 0.5s ease-out 0.2s both;\n}\n\n@keyframes checkDraw {\n  from { stroke-dasharray: 100; stroke-dashoffset: 100; }\n  to { stroke-dasharray: 100; stroke-dashoffset: 0; }\n}\n\n.gen-modal-title {\n  font-size: 22px;\n  font-weight: 800;\n  color: #2ea043;\n  letter-spacing: -0.3px;\n}\n\n.gen-modal-title.error-title {\n  color: var(--danger);\n}\n\n.gen-modal-desc {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin-bottom: 4px;\n}\n\n.gen-download-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 14px 24px;\n  background: linear-gradient(135deg, #2ea043, #27893a);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 4px;\n}\n\n.gen-download-btn:hover {\n  background: linear-gradient(135deg, #27893a, #1e6f2e);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(46, 160, 67, 0.35);\n}\n\n.gen-download-btn:active {\n  transform: translateY(0);\n}\n\n.gen-expire {\n  font-size: 11px;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.gen-close-btn {\n  background: none;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 10px 32px;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-top: 4px;\n}\n\n.gen-close-btn:hover {\n  border-color: var(--text-primary);\n  color: var(--text-primary);\n  background: var(--bg-primary);\n}\n\n/* ===== Auth Modal ===== */\n.auth-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--popup-overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.15s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.auth-modal {\n  background: var(--popup-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  width: 380px;\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.3);\n  animation: slideDown 0.25s ease-out;\n  overflow: hidden;\n}\n\n.auth-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 0;\n}\n\n.auth-header h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.auth-close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n  transition: color 0.15s;\n}\n\n.auth-close:hover {\n  color: var(--text-primary);\n}\n\n.auth-tabs {\n  display: flex;\n  margin: 16px 24px 0;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.auth-tab {\n  flex: 1;\n  padding: 10px;\n  background: none;\n  border: none;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s;\n}\n\n.auth-tab:hover {\n  color: var(--text-primary);\n}\n\n.auth-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.auth-form {\n  padding: 20px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.auth-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.auth-field label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-secondary);\n}\n\n.auth-field input {\n  padding: 10px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.auth-field input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.1);\n}\n\n.auth-error {\n  padding: 8px 12px;\n  background: rgba(248, 81, 73, 0.1);\n  border: 1px solid rgba(248, 81, 73, 0.3);\n  border-radius: 8px;\n  color: var(--danger);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.auth-submit {\n  padding: 11px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 4px;\n}\n\n.auth-submit:hover:not(:disabled) {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.3);\n}\n\n.auth-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.auth-google-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 14px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.auth-google-btn:hover:not(:disabled) {\n  background: var(--dropdown-hover);\n  border-color: var(--accent);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 12px rgba(74, 144, 217, 0.15);\n}\n\n.auth-google-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.auth-google-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.auth-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text-secondary);\n}\n\n.auth-divider::before,\n.auth-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--border-color);\n}\n\n.menu-action-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ===== Main Area ===== */\n.main-area {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.canvas-container {\n  flex: 1;\n  position: relative;\n}\n\n/* ===== Sidebar ===== */\n.sidebar {\n  width: 220px;\n  background: var(--bg-sidebar);\n  border-left: 1px solid var(--border-color);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex-shrink: 0;\n  overflow-y: auto;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sidebar-header h3 {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.sidebar-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: var(--accent);\n  color: #fff;\n  font-weight: 600;\n}\n\n.sidebar-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sidebar-section-bottom {\n  margin-top: auto;\n}\n\n.sidebar-info {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.sidebar-count {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Field action rows (Above / Below / Delete) */\n.field-action-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 0;\n}\n\n.field-action-label {\n  font-size: 13px;\n  color: var(--text-primary);\n}\n\n.field-action-btn {\n  background: none;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 4px 6px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.field-action-btn:hover:not(:disabled) {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.field-action-btn.delete:hover:not(:disabled) {\n  border-color: var(--danger);\n  color: var(--danger);\n}\n\n.field-action-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.field-count-input {\n  width: 56px;\n  padding: 4px 8px;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 13px;\n  text-align: center;\n}\n\n.sidebar-delete-table {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid var(--danger);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--danger);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.sidebar-delete-table:hover {\n  background: var(--danger);\n  color: #fff;\n}\n\n/* ===== Entity Node ===== */\n.entity-node {\n  width: 234px;\n  border: 2px solid var(--node-border);\n  border-radius: 4px;\n  background: var(--node-bg);\n  font-size: 13px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  cursor: move;\n}\n\n.entity-node.selected {\n  border-color: var(--node-selected-border);\n  box-shadow: 0 0 0 2px var(--node-selected-border), 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.entity-header {\n  padding: 6px 10px;\n  background: var(--node-header);\n  border-bottom: 1px solid var(--node-border);\n  text-align: center;\n  border-radius: 2px 2px 0 0;\n}\n\n.enum-header {\n  background: var(--enum-header);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.enum-node {\n  border-color: var(--enum-border);\n  border-radius: 12px;\n  width: 164px;\n}\n\n.enum-node .entity-header {\n  border-radius: 10px 10px 0 0;\n}\n\n.enum-node .entity-fields .entity-field-row:last-child {\n  border-radius: 0 0 10px 10px;\n}\n\n.enum-icon {\n  font-size: 14px;\n}\n\n.entity-name-input {\n  background: var(--input-bg);\n  border: none;\n  outline: none;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--node-header-text);\n  text-align: center;\n  width: 100%;\n  resize: none;\n  overflow: hidden;\n  line-height: 1.4;\n  font-family: inherit;\n  display: block;\n}\n\n.entity-name-input:focus {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 3px;\n}\n\n/* ===== Entity Fields ===== */\n.entity-fields {\n  display: flex;\n  flex-direction: column;\n}\n\n.entity-field-row {\n  display: flex;\n  align-items: center;\n  padding: 3px 4px;\n  border-bottom: 1px solid var(--border-color);\n  position: relative;\n  min-height: 28px;\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.entity-field-row:last-child {\n  border-bottom: none;\n}\n\n.entity-field-row.alt {\n  background: var(--node-field-alt);\n}\n\n.entity-field-row.field-selected {\n  background: var(--node-field-selected) !important;\n}\n\n.entity-field-row:hover {\n  background: var(--node-field-selected);\n}\n\n.field-type-cell {\n  flex: 1;\n  min-width: 0;\n  padding-right: 2px;\n}\n\n.field-type-cell.linked {\n  cursor: not-allowed;\n  opacity: 0.85;\n}\n\n.field-type-cell.linked .field-type-display {\n  color: var(--accent);\n}\n\n.enum-field-name {\n  flex: 1;\n}\n\n.field-name-cell {\n  flex: 1;\n  min-width: 0;\n}\n\n.field-name-input {\n  background: var(--input-bg);\n  border: none;\n  outline: none;\n  font-size: 12px;\n  color: var(--text-primary);\n  width: 100%;\n  padding: 2px 4px;\n  resize: none;\n  overflow: hidden;\n  line-height: 1.4;\n  font-family: inherit;\n  display: block;\n}\n\n.field-name-input:focus {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n.field-name-input:disabled {\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n/* ===== Display mode (read-only) ===== */\n.entity-name-display {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--node-header-text);\n  text-align: center;\n  padding: 2px 4px;\n  cursor: move;\n  user-select: none;\n  word-break: break-word;\n}\n\n.field-type-display {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-style: italic;\n  padding: 2px 4px;\n  user-select: none;\n  word-break: break-word;\n}\n\n.field-name-display {\n  font-size: 12px;\n  color: var(--text-primary);\n  padding: 2px 4px;\n  user-select: none;\n  word-break: break-word;\n}\n\n.field-name-display.id-field {\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.placeholder-text {\n  color: var(--text-secondary);\n  font-style: italic;\n  font-weight: 400;\n}\n\n/* ===== Draggable field rows ===== */\n.entity-field-row[draggable=\"true\"] {\n  cursor: grab;\n}\n\n.entity-field-row[draggable=\"true\"]:active {\n  cursor: grabbing;\n  opacity: 0.6;\n}\n\n.entity-field-row.drag-over {\n  border-top: 2px solid var(--accent);\n}\n\n.field-constraints {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n.constraint-btn {\n  width: 18px;\n  height: 18px;\n  border: 1px solid var(--border-color);\n  border-radius: 3px;\n  background: var(--constraint-bg);\n  color: var(--text-secondary);\n  font-size: 9px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transition: all 0.15s;\n}\n\n.constraint-btn.active {\n  background: var(--constraint-active);\n  color: #fff;\n  border-color: var(--constraint-active);\n}\n\n/* ===== Field Handles ===== */\n.field-handle {\n  width: 8px !important;\n  height: 8px !important;\n  background: var(--node-border) !important;\n  border: 2px solid var(--node-bg) !important;\n  min-width: 8px !important;\n  min-height: 8px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n}\n\n.field-handle:hover {\n  background: var(--accent) !important;\n  width: 10px !important;\n  height: 10px !important;\n}\n\n/* ===== Type Autocomplete ===== */\n.type-autocomplete {\n  position: relative;\n}\n\n.type-input {\n  width: 100%;\n  padding: 2px 4px;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  background: var(--input-bg);\n  color: var(--text-secondary);\n  font-style: italic;\n  resize: none;\n  overflow: hidden;\n  line-height: 1.4;\n  font-family: inherit;\n  display: block;\n}\n\n.type-input:focus {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n  color: var(--text-primary);\n  font-style: normal;\n}\n\n.type-dropdown {\n  position: absolute;\n  top: 100%;\n  left: -4px;\n  width: 150px;\n  max-height: 200px;\n  overflow-y: auto;\n  background: var(--dropdown-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n}\n\n.type-option {\n  padding: 5px 10px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.type-option:hover {\n  background: var(--dropdown-hover);\n}\n\n.type-option.active {\n  background: var(--dropdown-hover);\n  font-weight: 600;\n}\n\n/* ===== Connection Popup ===== */\n.connection-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--popup-overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.connection-popup {\n  background: var(--popup-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 24px;\n  min-width: 280px;\n  text-align: center;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.connection-popup h4 {\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.popup-desc {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n}\n\n.popup-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.popup-rel-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 20px;\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.popup-rel-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.popup-rel-icon {\n  color: var(--text-secondary);\n}\n\n.popup-rel-btn:hover .popup-rel-icon {\n  color: var(--accent);\n}\n\n.popup-rel-label {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.popup-cancel {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n/* ===== React Flow Overrides ===== */\n.react-flow__background {\n  background: var(--bg-primary) !important;\n}\n\n.react-flow__controls {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.react-flow__controls-button {\n  background: var(--bg-secondary) !important;\n  border-color: var(--border-color) !important;\n  color: var(--text-primary) !important;\n  fill: var(--text-primary) !important;\n}\n\n.react-flow__minimap {\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n}\n\n/* ===== Pricing Section ===== */\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 28px;\n  max-width: 1180px;\n  margin: 0 auto;\n  align-items: start;\n}\n\n.pricing-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 18px;\n  padding: 44px 36px;\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  position: relative;\n  transition: all 0.2s;\n}\n\n.pricing-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.pricing-card.popular {\n  border-color: var(--accent);\n  border-width: 2px;\n  box-shadow: 0 4px 24px rgba(74, 144, 217, 0.15);\n}\n\n.pricing-popular-badge {\n  position: absolute;\n  top: -14px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 6px 20px;\n  background: linear-gradient(135deg, var(--accent), #7c3aed);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  border-radius: 20px;\n  letter-spacing: 0.3px;\n}\n\n.pricing-card-header {\n  text-align: center;\n}\n\n.pricing-plan-name {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 14px;\n}\n\n.pricing-price {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.pricing-amount {\n  font-size: 48px;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -1.5px;\n}\n\n.pricing-old {\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-decoration: line-through;\n}\n\n.pricing-period {\n  font-size: 15px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.pricing-plan-desc {\n  font-size: 15px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.pricing-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  flex: 1;\n}\n\n.pricing-features li {\n  font-size: 15px;\n  color: var(--text-primary);\n  padding-left: 28px;\n  position: relative;\n  line-height: 1.5;\n}\n\n.pricing-features li::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 4px;\n  width: 18px;\n  height: 18px;\n  background: rgba(46, 160, 67, 0.15);\n  border-radius: 50%;\n}\n\n.pricing-features li::after {\n  content: '✓';\n  position: absolute;\n  left: 4px;\n  top: 2px;\n  font-size: 12px;\n  color: #2ea043;\n  font-weight: 700;\n}\n\n.pricing-features li.pricing-feature-includes {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--accent);\n  padding-bottom: 14px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid var(--border-color);\n  letter-spacing: 0.2px;\n}\n\n.pricing-features li.pricing-feature-includes::before {\n  background: var(--accent);\n  opacity: 0.15;\n}\n\n.pricing-features li.pricing-feature-includes::after {\n  content: '+';\n  color: var(--accent);\n  font-size: 17px;\n  top: 0;\n  left: 3px;\n}\n\n.pricing-beta-overlay {\n  text-align: center;\n}\n\n.pricing-beta-tag {\n  display: inline-block;\n  padding: 6px 16px;\n  background: linear-gradient(135deg, rgba(74, 144, 217, 0.1), rgba(130, 80, 223, 0.1));\n  border: 1px solid rgba(74, 144, 217, 0.2);\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--accent);\n  letter-spacing: 0.3px;\n}\n\n.pricing-btn {\n  width: 100%;\n  padding: 16px;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pricing-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.pricing-btn.current {\n  background: rgba(74, 144, 217, 0.1);\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.pricing-btn.pro {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n\n.pricing-btn.pro:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(74, 144, 217, 0.3);\n}\n\n.pricing-card.blurred .pricing-card-header,\n.pricing-card.blurred .pricing-features {\n  filter: blur(3px);\n  opacity: 0.5;\n  user-select: none;\n}\n\n.pricing-card.blurred {\n  position: relative;\n}\n\n.pricing-card.blurred:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.pricing-coming-soon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 8px 24px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.5px;\n  z-index: 2;\n}\n\n.pricing-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.comparison-block {\n  margin-top: 80px;\n  max-width: 1180px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.comparison-header {\n  text-align: center;\n  margin-bottom: 36px;\n}\n\n.comparison-header h3 {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 10px;\n}\n\n.comparison-header p {\n  font-size: 15px;\n  color: var(--text-secondary);\n}\n\n.comparison-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.comparison-card {\n  border-radius: 18px;\n  padding: 32px 28px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n.comparison-card.backora {\n  border-color: rgba(46, 160, 67, 0.4);\n  box-shadow: 0 4px 16px rgba(46, 160, 67, 0.08);\n}\n\n.comparison-card.diy {\n  opacity: 0.92;\n}\n\n.comparison-card-header {\n  text-align: center;\n  margin-bottom: 24px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.comparison-card-header h4 {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 6px 0;\n  color: var(--text-primary);\n}\n\n.comparison-card-header p {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.comparison-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.comparison-list li {\n  font-size: 14px;\n  color: var(--text-primary);\n  padding-left: 28px;\n  position: relative;\n  line-height: 1.5;\n}\n\n.comparison-card.backora .comparison-list li::before {\n  content: '✓';\n  position: absolute;\n  left: 4px;\n  top: 0;\n  color: #2ea043;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.comparison-card.diy .comparison-list li::before {\n  content: '⏱';\n  position: absolute;\n  left: 2px;\n  top: 0;\n  font-size: 14px;\n}\n\n.comparison-cta {\n  text-align: center;\n  margin-top: 32px;\n  font-size: 16px;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .comparison-grid {\n    grid-template-columns: 1fr;\n  }\n  .comparison-block {\n    margin-top: 56px;\n  }\n}\n\n.pricing-note {\n  text-align: center;\n  margin-top: 24px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .pricing-grid {\n    grid-template-columns: 1fr;\n    max-width: 400px;\n  }\n}\n\n.edge-code-tooltip {\n  background: var(--node-bg, var(--bg-secondary));\n  border: 1.2px solid var(--accent);\n  border-radius: 8px;\n  padding: 8px 12px;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.35);\n  z-index: 9999;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-size: 12px;\n  line-height: 1.5;\n  white-space: pre;\n}\n\n.edge-code-line {\n  color: var(--text-primary);\n}\n\n.edge-code-kw {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.edge-code-annotation {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.edge-code-type {\n  color: #e5c07b;\n}\n\n.edge-code-dots {\n  color: var(--text-secondary);\n}\n\n.edge-code-class {\n  font-weight: 600;\n}\n\n.edge-code-key {\n  color: #9cdcfe;\n}\n\n.edge-code-comment {\n  color: #6a9955;\n  font-style: italic;\n}\n\n.edge-code-indent {\n  padding-left: 14px;\n}\n\n/* Hover mode toggle (Code | JSON) — placed in floating-add-buttons */\n.floating-divider {\n  width: 1px;\n  height: 22px;\n  background: var(--border-color);\n  margin: 0 4px;\n}\n\n.hover-mode-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.hover-mode-label {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.hover-mode-btn {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.hover-mode-btn:hover {\n  border-color: var(--accent);\n  color: var(--text-primary);\n}\n\n.hover-mode-btn.active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n\n/* ========================================\n   RESPONSIVE - Mobile & Tablet\n   ======================================== */\n\n@media (max-width: 768px) {\n  /* Landing nav */\n  .landing-nav-links { display: none; }\n  .mobile-menu-btn { display: flex; }\n  .mobile-nav-dropdown { display: flex; }\n\n  .landing-nav {\n    padding: 12px 16px;\n  }\n\n  .landing-nav-actions {\n    gap: 6px;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n\n  .landing-btn-ghost,\n  .landing-btn-primary {\n    padding: 6px 14px;\n    font-size: 12px;\n  }\n\n  .landing-hero {\n    padding: 40px 20px 60px;\n  }\n\n  .hero-title {\n    font-size: 28px;\n  }\n\n  .hero-desc {\n    font-size: 14px;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n    width: 100%;\n    gap: 8px;\n  }\n\n  .hero-btn-primary,\n  .hero-btn-outline {\n    width: 100%;\n    justify-content: center;\n    padding: 12px;\n  }\n\n  .landing-features {\n    flex-direction: column;\n    padding: 30px 20px 50px;\n    gap: 16px;\n  }\n\n  .landing-section { padding: 48px 20px; }\n  .section-title { font-size: 24px; }\n  .how-steps { flex-direction: column; align-items: center; }\n  .how-step-arrow { transform: rotate(90deg); padding: 0; }\n  .features-grid { grid-template-columns: 1fr; }\n  .who-grid { grid-template-columns: 1fr 1fr; }\n  .contact-cards { flex-direction: column; align-items: center; }\n  .contact-card { min-width: auto; width: 100%; }\n  .landing-cta { padding: 48px 20px; }\n  .landing-cta h2 { font-size: 24px; }\n  .footer-content { flex-direction: column; gap: 24px; padding: 32px 20px; }\n  .footer-bottom { padding: 16px 20px; }\n\n  /* Home / Dashboard */\n  .home-nav {\n    padding: 12px 16px;\n  }\n\n  .home-content {\n    padding: 20px 16px;\n  }\n\n  .home-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  .home-title {\n    font-size: 20px;\n  }\n\n  .home-new-btn {\n    align-self: flex-start;\n  }\n\n  .home-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Profile */\n  .profile-content {\n    padding: 20px 16px;\n  }\n\n  .profile-title {\n    font-size: 20px;\n  }\n\n  .verify-code-row {\n    flex-direction: column;\n  }\n\n  /* Editor */\n  .main-layout {\n    flex-direction: column;\n    height: 100vh;\n  }\n\n  /* Side menu - overlay on mobile */\n  .side-menu {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 400;\n    height: 100vh;\n    width: 280px;\n    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.2);\n  }\n\n  .side-menu.collapsed {\n    left: -48px;\n    width: 48px;\n    box-shadow: none;\n  }\n\n  /* Right sidebar - overlay on mobile */\n  .sidebar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 350;\n    height: 100vh;\n    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.2);\n  }\n\n  .main-area {\n    flex: 1;\n    width: 100vw;\n  }\n\n  .canvas-container {\n    width: 100%;\n    height: 100%;\n  }\n\n  /* Floating buttons */\n  .floating-add-buttons {\n    top: auto;\n    bottom: 16px;\n    right: 16px;\n    flex-direction: column;\n  }\n\n  .floating-add-buttons.sidebar-open {\n    right: 16px;\n  }\n\n  .back-to-home {\n    top: 12px;\n    right: 12px;\n  }\n\n  .back-to-home.sidebar-open {\n    right: 12px;\n  }\n\n  .save-indicator {\n    bottom: 80px;\n    right: 12px;\n  }\n\n  /* Auth modal */\n  .auth-modal {\n    width: calc(100vw - 32px);\n    max-width: 380px;\n  }\n\n  /* Popups */\n  .connection-popup {\n    min-width: auto;\n    width: calc(100vw - 32px);\n    max-width: 360px;\n  }\n\n  .popup-buttons {\n    flex-direction: column;\n  }\n\n  .gen-modal {\n    width: calc(100vw - 32px);\n    max-width: 400px;\n    padding: 28px 20px 24px;\n  }\n\n  .confirm-modal {\n    width: calc(100vw - 32px);\n    max-width: 360px;\n  }\n\n  /* Profile menu */\n  .profile-menu {\n    right: -8px;\n    width: 180px;\n  }\n\n  /* Lang switcher compact */\n  .lang-btn {\n    padding: 3px 8px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 24px;\n  }\n\n  .landing-logo {\n    font-size: 15px;\n  }\n\n  .side-menu {\n    width: 260px;\n  }\n\n  .home-title {\n    font-size: 18px;\n  }\n\n  .entity-node {\n    width: 180px;\n  }\n\n  .enum-node {\n    width: 130px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
